import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Chip,
  Grid,
  IconButton,
  Link,
  Tooltip,
  Typography,
} from "@mui/material";
import Button from "../../common/Button";
import PageBackButton from "../../common/PageBackButton";
import {
  AppRegistrationOutlined,
  AssignmentOutlined,
  DeleteOutlineOutlined,
  DescriptionOutlined,
  Download,
  DownloadOutlined,
  FolderOutlined,
  GppMaybeOutlined,
  HealthAndSafetyOutlined,
  HistoryOutlined,
  LocalHospitalOutlined,
  ManageAccountsOutlined,
  MobileFriendlyOutlined,
  ModeOutlined,
  PendingActionsOutlined,
  PersonOutlined,
  PictureAsPdfOutlined,
  Preview,
  PreviewOutlined,
  ReceiptLongOutlined,
  ToggleOn,
  TrackChanges,
  TroubleshootOutlined,
  VerifiedUserOutlined,
  Wysiwyg,
  MedicationOutlined, // CS-2075
} from "@mui/icons-material";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import {
  Column,
  fetchDocumentByIdCommonApi,
  fetchManufacturersList,
  setSingleAlertObj,
  showHideLoadingDialog,
  SingleAlertInfo,
  useCommonReducer,
} from "../../../redux/slice/commonSlice";
import { fetchDocumentById } from "../../../redux/slice/practiceSlice";
import CustomIconButton from "../../common/CustomIconButton";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { changePatientStatus, deletePatient, fetchActivePatientBeneficationSummaryByPatientId, fetchPatientBeneficationSummaryByPatientId, fetchPatientDocumentsByIds, getPatient, getPatientSaveAuditLog, getPrescriptionsByPatientId, resetAutoPatientVerificationStatus, resetPatientActiveBeneficationInsuranceSummaryData, resetPatientActiveBeneficationSummaryData, savePatientVerificationDataSkipLoader, updatePatientEMRObjectReducer, updatePatientObjectReducer, usePatientReducer } from "../../../redux/slice/patient/patientSlice";
import { WoundInfo } from "../ivr/IVRForm";
import CustomTable, { Row } from "../../common/CustomTable";
import DocumentHistoryPopup from "./DocumentHistoryPopup";
import { fetchOrderDocumentsByIds, fetchOrdersList, fetchProductListIncludingInactiveByUserRoleOrderSlice, getOrderItemsByOrderId, getOrdersByPatientId, getPracticeListByUserRoleOrderSlicenew, OrderInfo, resetOrderListInfo, SearchOrder, useOrderSlice } from "../../../redux/slice/order/OrderSlice";
import { fetchIVRList, IvrListDTO, resetIVRList, searchIVRByPatientId, SearchIVRListRequest, useCreateIVRSlice } from "../../../redux/slice/ivr/createIVRSlice";
import { AI_SERVICE_NAME, CAN_ACCESS_APPLICATION, FETCH_TYPE_SUCCESS, IVR_STATUS_LIST, ORDER_ACTIONS, ORDER_AVAILABILITY, ORDER_INVOICE_STATUS, PATIENT_INSURANCE_NOT_FOUND_IN_EMR, PATIENT_IVR_INFO_TYPES, PATIENT_LIST_ACTIONS, PATIENT_STATUS, PRACTICE_TYPE, PRODUCT_CATEGORY, PRODUCT_STATUS, USER_ROLE_ENTITY_NAMES, AUDIT_ENTITYS } from "../../../constants/applicationConstants";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { selectIsTokenAvailable, selectIsValueFoundInToken, selectTokenValues, setSelectedModule, useAuthSlice } from "../../../redux/slice/authSlice";
import { extractInsuranceData, formatWoundName, fullName, getCategoryDisplayLabel, getComplianceColor, getStatusColor, hideElement } from "../../../utils/Utility";
import { INVALID_MBI_MESSAGE, isValidMedicareMbi } from "../../../utils/medicareMbi";
import { useNavigation } from "../../../hooks/useNavigation";
import { CodeTable, fetchAllCodeTablesValues, getCodeTableValuesByTableName, useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import React from "react";
import PDFViewer from "../../common/pdf/PDFViewer";
import { getPatientBeneficationSummary } from "../../../service/PatientService";
import PatientBenefitSummaryHistoryPopup from "./PatientBenefitSummaryHistoryPopup";
import BenefitVerificationErrorResponse from "./BenefitVerifiactionErrorResponse";
import PatientBenefitInsuranceDetailsPopup from "./PatientBenefitInsuranceDetailsPopup";
import { getSearchCriteriaFromSessionStorage, isPverifyAlreadyCalled, markPverifyAsCalled } from "../../../utils/StorageUtils";
import { checkAgreementsForPracticeBasedOnProductType, checkAncilliaryAgreementsForPractice } from "../../../redux/slice/productAgreement/createAgreementSlice";
import IVRPracticeSelectionPopup from "../ivr/IVRPracticeSelectionPopup";
import FixedAlertCard from "../../common/FixedAlertCard";
import { IVRInfo } from "../ivr/IVRList";
import { ProductInfo } from "../../../redux/slice/product/productListSlice";
import dayjs from "dayjs";
import ActionMenu, { ActionItem } from "../../common/ActionMenu";
import PatientRequestRx, { RequestRxPatient } from "../prescription/PatientRequestRx"; // CS-2075
import InfoPopup from "../../common/InfoPopup";
import CreateOrderIVRListPopup from "../orders/CreateOrderIVRListPopup";
import RecordPastOrderPopup from "../orders/RecordPastOrderPopup";
import OptionsPopup, { OptionPopupObjectProps } from "../../common/OptionsPopup";
import PatientEligibilityPopUp from "./PatientEligibilityPopUp";
import { unwrapResult } from "@reduxjs/toolkit";
import { OrderItemRow } from "../orders/TissueTrackingForMultipleOrders";
import { AiAuditInfo, getPatientAiAuditDataByPatientId, getRecentAiAuditDetailsByIdData, useAiAuditReducer } from "../../../redux/slice/AI/AiAuditSlice";
import MedicalNoteAuditPopup from "../aiMedicalAudit/MedicalNoteAuditPopup";
import { useModalStyles } from "../../common/useModalStyles";
import { useListPageStyles } from "../../common/useListPageStyles";
import { SectionHeader } from "../../ui/ContentSection";
import SectionTabNav, { SectionTabItem } from "../../common/SectionTabNav";


interface PatientInfo {
  firstName: string;
  middleName: string;
  lastName: string;
  birthDate: string;
  gender: string;
  practiceName: string;
  patientCode: string;
  status: string;
  dateOfSurgery: string;
  practiceSpecialization: string;
}

interface insuranceInfo {
  insuranceName?: string;
  primaryCommercialInsuranceName?: string;
  policy?: string;
  isPolicyUnderDifferentName?: string;
  policyholderFirstName?: string;
  policyholderMiddleName?: string;
  policyholderLastName?: string;
  policyHolderDOB?: string;
  isSecondaryInsurance?: boolean;
  secondaryInsuranceName?: string;
  secondaryPolicy?: string;
  secondaryCommercialInsuranceName?: string;
  isSecondaryPolicyUnderDifferentName?: string;
  secondarypolicyholderFirstName?: string;
  secondarypolicyholderMiddleName?: string;
  secondarypolicyholderLastName?: string;
  secondaryPolicyHolderDOB?: string;
  faceSheet?: string;
  insuranceCards?: string;
  secondaryInsuranceCards?: string;
};

interface FormatDocumentNameParams  {
  name: string;
  docId?: any;
};

const PatientDetails = () => {
  const { navigate } = useNavigation();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { documentDataFromCommonApi, manufacturerInfoList } = useCommonReducer();
  const { IVRListInfo } = useCreateIVRSlice();
  const { setValue } = useForm<any>();

  const alert = location.state?.alert;

  const ITEMS_PER_PAGE = 20;

  const downloadBase64File = (
    base64String: string,
    fileName: string,
    mimeType: string
  ) => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });
    const blobUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = blobUrl;
    anchor.download = fileName;
    document.body.appendChild(anchor); // Required for Firefox
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(blobUrl);
  };
  const [patientID, setPatientID] = useState(0);
  const [address, setAddress] = useState<string | null>(null);
  const [patientInfo, setPatientInfo] = useState<PatientInfo | null>(null);
  const [documentData, setDocumentData] = useState<any[]>([]);
  const [woundInfoRows, setWoundInfoRows] = useState<WoundInfo[]>([]);
  const [insuranceInformation, setInsuranceInformation] = useState<insuranceInfo>();

  const { patientInfoObject, patientActiveBeneficationSummaryData ,patientEmrData ,patientCreationStatusByEmr,autoPatientVerificationDataStatus, prescriptions } = usePatientReducer();
  const { ordersByPatient, productsByUserRoleOrderSlice, orderListInfo, fetchProductsByRoleStatusOrderSlice } = useOrderSlice();

  const [maxWoundRowIndex, setMaxWoundRowIndex] = useState(0);
  const [showHistoryPopup, setShowHistoryPopup] = useState(false);
  const [activeTab, setActiveTab] = useState("");
  const { tokens: mTokens, isDark: isDarkModal } = useModalStyles();
  const { tableSx } = useListPageStyles();
  // Keep InvoiceList table chrome, but do not override CustomIconButton colors in Action columns
  const patientTableSx = {
    ...tableSx,
    "& .MuiIconButton-root": {
      borderRadius: "8px",
      "&:hover": {
        backgroundColor: isDarkModal ? "rgba(20,184,166,0.12)" : "rgba(20,184,166,0.08)",
      },
    },
  };
  const cardSx = {
    borderRadius: "16px",
    border: `1px solid ${mTokens.border}`,
    backgroundColor: mTokens.bg,
    backgroundImage: "none",
    overflow: "hidden" as const,
    boxShadow: isDarkModal ? "0 10px 20px rgba(0,0,0,0.1)" : "none",
  };
  // Matches the IVR Details / Patients List outlined accent chrome
  const outlineAccentBtnSx = {
    textTransform: "none" as const,
    fontWeight: 700,
    fontSize: "0.82rem",
    borderRadius: "10px",
    height: 36,
    px: 1.6,
    color: mTokens.accent,
    borderColor: mTokens.accent,
    backgroundColor: "transparent",
    whiteSpace: "nowrap" as const,
    letterSpacing: "0.04em",
    "&:hover": {
      backgroundColor: `${mTokens.accent}14`,
      borderColor: mTokens.accent,
      boxShadow: "none",
    },
    "& .MuiTypography-root": { color: `${mTokens.accent} !important` },
    "& .MuiButton-startIcon, & .MuiButton-endIcon": { color: mTokens.accent },
  };
  const InfoRow = ({ label, value }: { label: string; value?: React.ReactNode }) => (
    <Box display="flex" alignItems="flex-start" py={0.4} sx={{ borderBottom: `1px solid ${mTokens.border}`, "&:last-child": { borderBottom: "none" }, gap: 1 }}>
      <Typography sx={{ fontSize: "0.82rem", color: mTokens.textSecondary, width: "38%", maxWidth: "42%", minWidth: 88, flexShrink: 0, pt: 0.15 }}>
        {label}
      </Typography>
      <Box sx={{ fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 600, flex: 1, minWidth: 0, wordBreak: "break-word" }}>
        {value ?? "—"}
      </Box>
    </Box>
  );
  const fieldLabelSx = { fontSize: "0.68rem", fontWeight: 700, color: mTokens.textSecondary, textTransform: "uppercase" as const, letterSpacing: "0.06em", mb: 0.3 };
  const fieldValueSx = { fontSize: "0.88rem", color: mTokens.textPrimary, fontWeight: 600 };
  const subSectionTitleSx = { fontSize: "0.92rem", fontWeight: 700, color: mTokens.textPrimary };
  const canEditPatient = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.EDIT)(state));
  const canViewHistory = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.HISTORY)(state));
  const canAccessProviderProducts = useSelector((state: RootState) => selectTokenValues("canAccessProviderProducts")(state));
  const [showPDF, setShowPDF] = useState<{ isShow: boolean, patientName: string, fileName: string }>({ isShow: false, patientName: "", fileName: "" });
  const [showPatientBenefitSummaryHistoryPopup, setShowPatientBenefitSummaryHistoryPopup] = useState(false);
  const [showPatientBenefitInsuranceSummaryHistoryPopup, setShowPatientBenefitInsuranceSummaryHistoryPopup] = useState(false);
  const [bvsid, setBvsId] = useState<number|null>(null);
  const { userInfo } = useAuthSlice();
  const [showIVRSelectionPopup, setShowIVRSelectionPopup] = useState(false);
  const { allCodeTablesValuesMap, allCodeTableValueFetchStatus } = useCodetablesSlice();
  const [documentTypes, setDocumentTypes] = useState<CodeTable[]>([]);
  const [pdfContent, setPDFContent] = useState<string>("");
  const [ivrOrdersLoaded, setIvrOrdersLoaded] = useState(false);
  const [sectionListsReady, setSectionListsReady] = useState(false);
  const [benefitSummaryReady, setBenefitSummaryReady] = useState(false);
  const [autoEligibilitySettled, setAutoEligibilitySettled] = useState(false);
  const [selectedHistoryData, setSelectedHistoryData] = useState<any[]>([]);
  const [showErrorResponsePopup, setShowErrorResponsePopup] = useState<{ isShow: boolean, errorResponse: string }>({ isShow: false, errorResponse: "" });
  //CS-1297 - Start
  const [loadingPverify, setLoadingPverify] = useState(false);
  const [pverifyResults, setPverifyResults] = useState<any[]>([]);
  const hasTriggeredPverifyRef = useRef(false);
  const canCreateIVR = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.CREATE_IVR)(state));
  const canCreateOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.CREATE_ORDER)(state));
  const canRecordPastOrder = useSelector((state: RootState) => selectIsTokenAvailable("canRecordPastOrder")(state));
  const canViewEligibilityErrorResponse = useSelector((state: RootState) => selectIsTokenAvailable("canViewEligibilityErrorResponse")(state));
  const canDeletePatient = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.DELETE)(state));
  const canAccessBenefitVerification = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.PVERIFY)(state));
  const canRecordTX = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.RECORD_TX)(state));
  // CS-2075 START
  const canRequestRx = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.REQUEST_RX)(state));
  const [rxPatient, setRxPatient] = useState<RequestRxPatient | null>(null);
  // CS-2075 END
  const canClosePatient = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.CLOSE_PATIENT)(state));
  const canReOpenPatient = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.REOPEN_PATIENT)(state));

  const canAuditPatient = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessAuditAction", AUDIT_ENTITYS.PATIENTAUDIT)(state));
  
  // CS-1595 - Token check for Medical Audit access
  const hasSubscribedAccessToMedicalAudit = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessApplication", CAN_ACCESS_APPLICATION.MEDICAL_NOTE_AUDIT)(state));

  const [ ivrListByPatient, setIvrListByPatient ] = useState<IvrListDTO[] | null>(null);
  const patientId = patientInfoObject?.patientId;
  const [filteredeProductsByUserRoleOrderSlice, setFilteredeProductsByUserRoleOrderSlice] = useState<ProductInfo[]>();
  //CS-1406
  const canDetailOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessOrderActions", ORDER_ACTIONS.DETAILS)(state));
  const [selectedPatient, setSelectedPatient] = useState<{ patientId: number, practiceId: number, practiceName?: string | null, providerId?: number | null } | null>(null);
  const [selectedPatientData, setSelectedPatienData] = useState<any>({});
  const [showIVRListPopup, setShowIVRListPopup] = useState(false);
  const [showRecordPastOrderPopup, setShowRecordPastOrderPopup] = useState(false);
  const [confirmDeleteOptionPopup, setConfirmDeleteOptionPopup] = useState(false);
  const [showEligibilityPopup, setShowEligibilityPopup] = useState(false);
  const [verifyBenefitClick,setVerifyBenefitClick] =useState(false) 
  // const[patientData,setPatientData] = useState<any>(null);
  const [showOptionPopup, setShowOptionsPopup] = useState<OptionPopupObjectProps>({ message: '', show: false });
  const [fetchPatient, setFetchPatient] = useState(false) 
  
  //CS-1297 - End
  
  // Medical Audit List state
  const [medicalAuditData, setMedicalAuditData] = useState<any[]>([]);
  const [showMedicalAuditPopup, setShowMedicalAuditPopup] = useState(false);
  const [selectedMedicalAuditData, setSelectedMedicalAuditData] = useState<any>(null);
  const patientBenefitSummaryColumn: Column[] = [
    { id: "requestedDateTimeAndName", label: "Requested Date Time", minWidth: 100 },
    { id: "provider", label: "Provider", minWidth: 100 },
    { id: "insurance", label: "Insurance", minWidth: 100 },
    { id: "policyNo", label: "Policy #", minWidth: 100 },
    { id: "status", label: "Status", minWidth: 100 },
    { id: "actionButtons", label: "Action", minWidth: 100 },
  ];

  /* Codes (CPT/L/E/I) and Measurements (dimensions/area/volume) are each
     consolidated into a single compact multi-line cell — see `codes`/
     `measurements` synthesized in `woundInfoTableRows` below — so the table
     reads in fewer columns and matches IVRForm.tsx / CreatePatient.tsx's
     baseWoundColumns. */
  const baseWoundColumns: Column[] = [
    { id: "woundKeyDisplayValue", label: "ID", minWidth: 20 },
    { id: "woundType", label: "Type", minWidth: 80 },
    { id: "codes", label: "Codes (CPT/L Code/E Code/I Code)", minWidth: 90 },
    { id: "procedureLocation", label: "Location", minWidth: 80 },
    { id: "otherDxCodes", label: "Dx Code(s) / ICD-10", minWidth: 80 },
    { id: "exudate", label: "Exudate", minWidth: 80 },
    { id: "measurements", label: "Measurements (L, W, D / Area / Volume)", minWidth: 160 },
  ];

  const ivrColumn: Column[] = [
    { id: "orderId", label: "IVR ID", minWidth: 100 },
    { id: "provider", label: "Provider", minWidth: 100 },
    { id: "product", label: "Product", minWidth: 100 },
    { id: "status", label: "Status", minWidth: 100 },
    { id: "dos", label: "Date Of Service", minWidth: 100 },
  ];

  const orderColumn: Column[] = [
    { id: "orderId", label: "Order ID", minWidth: 100 },  //CS-1404
    { id: "provider", label: "Provider", minWidth: 100 },
    { id: "product", label: "Product", minWidth: 100 },
    { id: "status", label: "Status", minWidth: 100 },
    { id: "dos", label: "Date Of Service", minWidth: 100 },
  ];

  const medicalAuditColumn: Column[] = [
    { id: "auditIdLink", label: "Audit ID", minWidth: 100 },
    { id: "fileName", label: "File Name", minWidth: 150 },
    { id: "uploadDate", label: "Upload Date", minWidth: 120 },
    { id: "uploadedBy", label: "Uploaded By", minWidth: 120 },
    { id: "complianceScore", label: "Compliance %", minWidth: 100 },
    // { id: "action", label: "Action", minWidth: 100 },
  ];

  const prescriptionColumn: Column[] = [
    { id: "providerName", label: "Provider Name", minWidth: 120 },
    { id: "location", label: "Location", minWidth: 180 },
    { id: "createdAt", label: "Created Date", minWidth: 120 },
    { id: "actionButtons", label: "Action", minWidth: 80 },
  ];

  const [showInfoPopup, setShowInfoPopup] = useState<{ message: string, show: boolean, title: string }>({ message: "", show: false, title: "" });

  const onClickInfoPopup = () => {
    setShowInfoPopup({ message: "", show: false, title: "" })
  }

  const handleAlert = (message: string, type: "success" | "error" | "info") => {
    const alertObj: SingleAlertInfo = {
      message,
      alertType: type,
    };
    dispatch(setSingleAlertObj(alertObj));
  };

  // const handleViewMedicalAudit = async (auditId: string) => {
  //   try {
  //     const response = await dispatch(getRecentAiAuditDetailsByIdData(auditId));
  //     if (response.meta.requestStatus === "fulfilled" && response.payload?.data) {
  //       setSelectedMedicalAuditData(response.payload.data);
  //       setShowMedicalAuditPopup(true);
  //     } else {
  //       handleAlert("Failed to load audit details. Please try again.", "error");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching medical audit details:", error);
  //     handleAlert("Error loading audit details. Please try again.", "error");
  //   }
  // };

    const handleRowNavigateToDetails = useCallback((row: Row) => {
      const auditRow = row as AiAuditInfo;
        navigate('/ai_audit_details', {
          state: { auditId: auditRow.auditId }
        });
    }, [ navigate]);

  const handleCloseMedicalAuditPopup = () => {
    setShowMedicalAuditPopup(false);
    setSelectedMedicalAuditData(null);
  };

  const onCreateIVRClick = async () => {
    if (patientInfoObject?.status === PATIENT_STATUS.DRAFTED) {
      setShowInfoPopup({ message: "Patient information is incomplete. Please complete the patient details before proceeding.", show: true, title: "Create IVR" })
    } else {
      if (patientInfoObject?.practiceId) {
        const response = await dispatch(checkAncilliaryAgreementsForPractice(patientInfoObject.practiceId));
        if (userInfo?.entityName !== USER_ROLE_ENTITY_NAMES.ADMIN && canCreateIVR) {
          navigate("/ivr", {
            state: {
              practiceId: patientInfoObject.practiceId,
              ivrEmailNotification: true,
              patientData: { from: CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT, patientId: patientInfoObject?.patientId },
              // CS-1728 - Replacing static label to dynamic constant
              productCategory: response.payload === true ? PRODUCT_CATEGORY.CONSERVATIVE : PRODUCT_CATEGORY.ADVANCED,
            }
          });
        } else {
          setShowIVRSelectionPopup(true);
        }
      }
    }
  }

  const onCreateOrderClick = async () => {
    setSelectedPatient({
      patientId: patientInfoObject?.patientId || 0,
      practiceId: patientInfoObject?.practiceId || 0,
      practiceName: patientInfoObject?.practiceName,
      providerId: patientInfoObject?.providerId
    })
    setSelectedPatienData({
      firstName: patientInfoObject?.firstName,
      middleName: patientInfoObject?.middleName,
      lastName: patientInfoObject?.lastName,
      dob: patientInfoObject?.birthDate,
      gender: patientInfoObject?.gender
    })
    if (patientInfoObject?.status === PATIENT_STATUS.DRAFTED) {
      setShowInfoPopup({ message: "Patient information is incomplete. Please complete the patient details before proceeding.", show: true, title: "Create Order" })
    } else {
      if (patientInfoObject?.practiceId) {
        const response = await dispatch(checkAgreementsForPracticeBasedOnProductType(patientInfoObject?.practiceId));
        if (response?.payload && response?.payload?.hasAdvancedCTPsAgreement === true && response?.payload?.hasAncilliaryAgreement === true) {
          setShowIVRListPopup(true);
          setSelectedPatient({
            patientId: patientInfoObject?.patientId || 0,
            practiceId: patientInfoObject?.practiceId || 0,
            practiceName: patientInfoObject?.practiceName
          })
          setSelectedPatienData({
            firstName: patientInfoObject?.firstName,
            middleName: patientInfoObject?.middleName,
            lastName: patientInfoObject?.lastName,
            dob: patientInfoObject?.birthDate,
            gender: patientInfoObject?.gender
          })
        } else if (response?.payload && response?.payload?.hasAdvancedCTPsAgreement === true && response?.payload?.hasAncilliaryAgreement === false) {
          setShowIVRListPopup(true);
          setSelectedPatient({
            patientId: patientInfoObject?.patientId || 0,
            practiceId: patientInfoObject?.practiceId || 0,
            practiceName: patientInfoObject?.practiceName
          })
          setSelectedPatienData({
            firstName: patientInfoObject?.firstName,
            middleName: patientInfoObject?.middleName,
            lastName: patientInfoObject?.lastName,
            dob: patientInfoObject?.birthDate,
            gender: patientInfoObject?.gender
          })
        } else if (response?.payload && response?.payload?.hasAdvancedCTPsAgreement === false && response?.payload?.hasAncilliaryAgreement === true) {
          // setShowAncillaryForm(true);
          setShowIVRListPopup(true);
        } else {
          const alertObj: SingleAlertInfo = {
            message: "There is no active agreement found. You can not create order.",
            alertType: "error",
          };
          dispatch(setSingleAlertObj(alertObj));
        }
      }
    }
  }

  const handleRecordPastOrderPopup = () => {
    setShowRecordPastOrderPopup(!showRecordPastOrderPopup);
  }

  const onRecordPastOrderClick = async () => {
    if (patientInfoObject?.status === PATIENT_STATUS.DRAFTED) {
      setShowInfoPopup({ message: "Patient information is incomplete. Please complete the patient details before proceeding.", show: true, title: "Create Order" })
    } else {
      setSelectedPatient({
        patientId: patientInfoObject?.patientId || 0,
        practiceId: patientInfoObject?.practiceId || 0
      })
      setSelectedPatienData({
        firstName: patientInfoObject?.firstName,
        middleName: patientInfoObject?.middleName,
        lastName: patientInfoObject?.lastName,
        dob: patientInfoObject?.birthDate,
        gender: patientInfoObject?.gender
      })
      handleRecordPastOrderPopup();
    }
  }

  const onDeleteClick = async () => {
    setSelectedPatient({
      patientId: patientInfoObject?.patientId || 0,
      practiceId: patientInfoObject?.practiceId || 0
    })
    setConfirmDeleteOptionPopup(true)
  }

  // const deletePatientbyId = async () => {
  //   const res = await dispatch(deletePatient({ patientId: selectedPatient?.patientId ? selectedPatient.patientId.toString() : "" }));
  //   handleAlert(`Patient has been deleted successfully..`, "success");
  //   setConfirmDeleteOptionPopup(false);
  //   navigate("/patients", { state: { withSearchHistory: true } });
  // }

  
  // CS - 1790 - Fix the issue of success & failure both toast message simultaneously shown after patient deletion
    const deletePatientbyId = async () => {
      setConfirmDeleteOptionPopup(false);
      try {
        await dispatch(
          deletePatient({
            patientId: selectedPatient?.patientId
              ? selectedPatient.patientId.toString()
              : "",
          }),
        ).unwrap();
        handleAlert(`Patient has been deleted successfully..`, "success");
        navigate("/patients", { state: { withSearchHistory: true } });
      } catch {
        // Error toast handled globally by axios interceptor (http.ts)
      }
    };

  // const onEditClick = async () => {
  //   navigate('/editPatient', { state: { patientDetails: { isPatientEdit: true, patientId: patientInfoObject?.patientId } } })
  // }

  const onVerifyBenefitClick = async () => {
    setSelectedPatient({
      patientId: patientInfoObject?.patientId || 0,
      practiceId: patientInfoObject?.practiceId || 0,
      practiceName: patientInfoObject?.practiceName
    })
    // setVerifyBenefitClick(true)
    setShowEligibilityPopup(true);

  }

  const handleRecordTXClick = async () => {
    const response = await dispatch(getOrdersByPatientId(patientInfoObject?.patientId))
    if (response.payload && response.payload.code === "V3OK" && response.payload.message === "SUCCESS" &&
      (!response.payload.errors || response.payload.errors.length === 0)) {
      if (response.payload.data && response.payload.data.length > 0) {
        const ordersByPatient: OrderInfo[] = response.payload.data;
        try {
          const deliveredOrders = ordersByPatient.filter(order => order.orderStatus === 'DELIVERED');

          if (deliveredOrders.length === 0) {
            return setShowOptionsPopup({
              show: true,
              variant: "warning",
              message: (
                <>
                  <strong>No delivered orders were found:</strong> Record Tx only allows for delivered orders.
                  <br />
                  Please make sure the patient has at least one delivered order before proceeding.
                </>
              ),
              buttons: [
                {
                  name: "OK",
                  color: "warning",
                  onClick: () => {
                    setShowOptionsPopup({ show: false, message: "" });
                  },
                },
              ],
            });
          }

          const promises = deliveredOrders.map(order =>
            dispatch(getOrderItemsByOrderId(order.orderId)).then(unwrapResult)
          );
          const results = await Promise.all(promises);
          const combinedItems: OrderItemRow[] = results.flatMap(result => result.data);
          //CS-1248 - Replacing hard coded product category with constant
          const allAncillary = combinedItems.every(item => item.productCategory === PRODUCT_CATEGORY.CONSERVATIVE);
          if (combinedItems.length > 0 && allAncillary) {
            return setShowOptionsPopup({
              show: true,
              variant: "warning",
              message: (
                <>
                  <strong>Not supported:</strong> Record Tx is not supported for {getCategoryDisplayLabel(allCodeTablesValuesMap, PRODUCT_CATEGORY.CONSERVATIVE)}.
                </>
              ),
              buttons: [
                {
                  name: "OK",
                  color: "warning",
                  onClick: () => {
                    setShowOptionsPopup({ show: false, message: "" });
                  },
                },
              ],
            });
          }

          const updatedItems = combinedItems
            //CS-1248 - Replacing hard coded product category with constant
            .filter(item => item.productCategory !== PRODUCT_CATEGORY.CONSERVATIVE)
            .map(item => {
              const tissueTrackingInfo: Record<string, any> = item.tissueTrackingInfo || {};
              const woundKey = `woundData_${item.orderItemId}`;
              const woundDetails = tissueTrackingInfo[woundKey] || {};

              return {
                ...item,
                woundLocation: woundDetails?.woundLocationLabel || null,
              };
            })
            .sort((a, b) => a.units - b.units);
          navigate('/multiple_tissue_tracking', { state: { patientId: patientInfoObject?.patientId, patientName: fullName("",patientInfoObject?.firstName,patientInfoObject?.middleName,patientInfoObject?.lastName), orderItems: updatedItems } })
        } catch (error) {
          return setShowOptionsPopup({
            show: true,
            variant: "error",
            message: (
              <>
                <strong>Error:</strong> An error occurred while fetching order items.
                <br />
                Please try again or contact support if the issue persists.
              </>
            ),
            buttons: [
              {
                name: "OK",
                color: "error",
                onClick: () => {
                  setShowOptionsPopup({ show: false, message: "" });
                },
              },
            ],
          });
        }
      } else {
        return setShowOptionsPopup({
          show: true,
          variant: "warning",
          message: (
            <>
              <strong>No orders were found:</strong> No orders were found for this patient.
              <br />
              Please verify the patient's information or try again.
            </>
          ),
          buttons: [
            {
              name: "OK",
              color: "warning",
              onClick: () => {
                setShowOptionsPopup({ show: false, message: "" });
              },
            },
          ],
        });
      }
    } else {
      return setShowOptionsPopup({
        show: true,
        variant: "error",
        message: (
          <>
            <strong>Error:</strong> An error occurred while fetching the orders.
            <br />
            Please try again or contact support if the issue persists.
          </>
        ),
        buttons: [
          {
            name: "OK",
            color: "error",
            onClick: () => {
              setShowOptionsPopup({ show: false, message: "" });
            },
          },
        ],
      });
    }
  }

  const handleChangeStatusToClosed = async () => {
    const response = await dispatch(changePatientStatus({ patientId: patientInfoObject?.patientId, status: PATIENT_STATUS.CLOSED }));
    if (response.meta.requestStatus === 'fulfilled') {
      setFetchPatient(true);
      handleAlert("Patient record closed successfully", "success");
    }
    setShowOptionsPopup({ show: false, message: "" });
  }

  const handleClosePatient = () => {
    setShowOptionsPopup({
      message: `Do you really want to close the patient record ?`,
      show: true,
      variant: "confirm",
      buttons: [{ name: "Confirm", color: 'primary', onClick: () => handleChangeStatusToClosed() }, { name: "Cancel", color: 'secondary', onClick: () => setShowOptionsPopup({ show: false, message: "" }) }]
    });
  }

  const handleChangeStatusToActivate = async () => {
    const response = await dispatch(changePatientStatus({ patientId: patientInfoObject?.patientId, status: PATIENT_STATUS.ACTIVE }));
    if (response.meta.requestStatus === 'fulfilled') {
      setFetchPatient(true);
      handleAlert("Patient record activated successfully", "success");
    }
    setShowOptionsPopup({ show: false, message: "" });
  }

  const handleActivatePatient = () => {
    setShowOptionsPopup({
      message: `Do you really want to reactivate the patient record ?`,
      show: true,
      variant: "confirm",
      buttons: [{ name: "Confirm", color: 'primary', onClick: () => handleChangeStatusToActivate() }, { name: "Cancel", color: 'secondary', onClick: () => setShowOptionsPopup({ show: false, message: "" }) }]
    });
  }

  const handleClickPatientAudit = () => {

    const entityName = fullName(null, patientInfoObject?.firstName, patientInfoObject?.middleName, patientInfoObject?.lastName);

    if (patientInfoObject && entityName) {
      const PatientAuditData = {
        entityName: "PATIENT",
        entityNumber: entityName,
      }
      const url = `/auditlog?entityName=${PatientAuditData.entityName}&entityNumber=${PatientAuditData.entityNumber}`;
      window.open(url, '_blank');
    }
  }

  const actions: ActionItem[] = [
    {
      label: "Create IVR",
      icon: <ManageAccountsOutlined fontSize="small" />,
      color: "warning",
      onClick: () => onCreateIVRClick(),
      isHidden: !(canCreateIVR && patientInfoObject?.status === PATIENT_STATUS.ACTIVE)
    },
    {
      label: "Create Order",
      icon: <AppRegistrationOutlined fontSize="small" />,
      color: "success",
      onClick: () => onCreateOrderClick(),
      isHidden: !(canCreateOrder && patientInfoObject?.status === PATIENT_STATUS.ACTIVE)
    },
    {
      label: "Record Past Order",
      icon: <PendingActionsOutlined fontSize="small" />,
      color: "info",
      onClick: () => onRecordPastOrderClick(),
      isHidden: !(patientInfoObject?.status !== PATIENT_STATUS.DRAFTED && patientInfoObject?.status !== PATIENT_STATUS.CLOSED && canRecordPastOrder)
    },
    {
      label: "Delete",
      icon: <DeleteOutlineOutlined fontSize="small" />,
      color: "error",
      onClick: () => onDeleteClick(),
      isHidden: !(canDeletePatient && patientInfoObject?.status === PATIENT_STATUS.DRAFTED)
    },
    // {
    //   label: "Edit",
    //   icon: <ModeOutlined fontSize="small" />,
    //   color: "info",
    //   onClick: () => onEditClick(),
    //   isHidden: !(canEditPatient)
    // },
    {
      label: "Auto-Eligibility",
      icon: <VerifiedUserOutlined fontSize="small" />,
      color: "error",
      onClick: () => onVerifyBenefitClick(),
      isHidden: !(patientInfoObject?.status !== PATIENT_STATUS.DRAFTED && patientInfoObject?.status !== PATIENT_STATUS.CLOSED && canAccessBenefitVerification)
    },
    {
      label: "Record Tx",
      icon: <TroubleshootOutlined fontSize="small" />,
      color: "success",
      onClick: () => handleRecordTXClick(),
      isHidden: !(canRecordTX && patientInfoObject?.status === PATIENT_STATUS.ACTIVE)
    },
    // CS-2075 — same gate as the Patient List row button
    {
      label: "Request Rx",
      icon: <MedicationOutlined fontSize="small" />,
      color: "success",
      onClick: () => setRxPatient({ patientId: Number(patientInfoObject?.patientId), practiceId: Number(patientInfoObject?.practiceId) }),
      isHidden: !(canRequestRx && patientInfoObject?.status === PATIENT_STATUS.ACTIVE && !!patientInfoObject?.practiceId)
    },
    {
      label: "Close Patient",
      icon: <MobileFriendlyOutlined fontSize="small" />,
      color: "error",
      onClick: () => handleClosePatient(),
      isHidden: !(canClosePatient && (patientInfoObject?.status === PATIENT_STATUS.ACTIVE))
    },
    {
      label: "Reopen (Active)",
      icon: <ToggleOn fontSize="small" />,
      color: "success",
      onClick: () => handleActivatePatient(),
      isHidden: !(canReOpenPatient && patientInfoObject?.status === PATIENT_STATUS.CLOSED)
    },
    {
      label: "Patient Audit",
      icon: <TrackChanges fontSize="small" />,
      color: "warning",
      onClick: () => handleClickPatientAudit(),
      isHidden: !canAuditPatient
    }
  ];

  const ivrSummaryRows = useMemo(() => {
    if (!IVRListInfo?.content?.length) return [];

    return [...IVRListInfo.content]
      .sort((a, b) => b.ivrId - a.ivrId)
      .slice(0, 3)
      .map((ivr) => ({
        // orderId: ivr.ivrNumber || "-",
        //CS-1406 - Render ivr number as a link
        orderId: ivr?.ivrId ? (
          <Link
            component="button"
            underline="hover"
            variant="body2"
            onClick={() => {
              navigate("/ivr_details", {
                state: {
                  ivrInfo: { ...ivr, patient: fullName(null,ivr.patientFirstName, ivr.patientMiddleName, ivr.patientLastName), dateCreated: ivr.auditTimestamp },
                }
              })
            }}
            color={'#00B8D9'}
          >
            {ivr?.ivrNumber}
          </Link>
        ) : (
          ivr?.ivrNumber
        ),
        product: ivr.productName || "-",
        provider: ivr.providerName || "-",
        status: (
          <Chip
            label={ivr.verificationStatus}
            size="small"
            sx={{
              color: getStatusColor(ivr.verificationStatus),
              backgroundColor: "#f5eaea0f",
            }}
          />
        ),
        dos: ivr.dateOfService || "-",
      }));
  }, [IVRListInfo]);

  const orderSummaryRows = useMemo(() => {
    if (!orderListInfo?.content?.length) return [];

    return [...orderListInfo.content]
      .sort((a, b) => b.orderId - a.orderId)
      .slice(0, 3)
      .map((order) => ({
        // orderId: order.orderNumber || "-",
        //CS-1406 - Render ordernumber link
        orderId: order.orderNumber !== null && canDetailOrder ? (
          <Link
            component="button"
            underline="hover"
            variant="body2"
            onClick={() =>  {navigate("/details/1", { state: { orderDetails: order } })}}
            color={'#00B8D9'}
          >
            {order.orderNumber}
          </Link>
        ) : (
          order.orderNumber
        ),
        product: order.productName || "-",
        provider: order.orderInfo?.provider || "-",
        status: (
          <Chip
            label={order.orderStatus}
            size="small"
            sx={{
              color: getStatusColor(order.orderStatus),
              backgroundColor: "#f5eaea0f",
            }}
          />
        ),
        dos: order.dateOfService || "-",
      }));
  }, [orderListInfo]);




  // const shouldShowExudate = useMemo(() => {
  //     return woundInfoRows.some(row => row.woundType === "Surgical Incision");
  // }, [woundInfoRows]);
  
  const woundInfoTableColumns: Column[] = useMemo(() => {
      const filteredColumns = baseWoundColumns.filter(
          column => !((column.id === "codes" || column.id === "exudate") && patientInfo?.practiceSpecialization === PRACTICE_TYPE.SURGICAL)
      );
      // const insertIndex = filteredColumns.findIndex(col => col.id === "displayTotalSize");
      // if (shouldShowExudate && insertIndex !== -1) {
      //     const exudateColumn = { id: "exudate", label: "Exudate", minWidth: 80 };
      //     return [
      //         ...filteredColumns.slice(0, insertIndex),
      //         exudateColumn,
      //         ...filteredColumns.slice(insertIndex)
      //     ];
      // }
      return filteredColumns;
  }, [patientInfo?.practiceSpecialization]);

  const woundInfoTableRows = useMemo(() => {
    return (woundInfoRows || []).map((row: any) => {
      const codeParts = [
        row.cpt && `CPT: ${row.cpt}`,
        row.lCode && `L Code: ${row.lCode}`,
        row.eCode && `E Code: ${row.eCode}`,
        row.iCode && `I Code: ${row.iCode}`,
      ].filter(Boolean);
      const measurementParts = [
        row.displayWoundDimensions && `Dimensions: ${row.displayWoundDimensions}`,
        row.displayEstimateSurfaceArea && `Area: ${row.displayEstimateSurfaceArea}`,
        row.displayTotalWoundVolume && `Volume: ${row.displayTotalWoundVolume}`,
      ].filter(Boolean);
      return {
        ...row,
        codes: codeParts.length > 0 ? codeParts.join(" • ") : "-",
        measurements: measurementParts.length > 0 ? measurementParts.join(" • ") : "-",
      };
    });
  }, [woundInfoRows]);

  const handleHistoryPopup = () => {
    setShowHistoryPopup((prev) => !prev);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(setSelectedModule("Patient"));
  }, []);
  
  //CS-1244 -Start
  useEffect(() => {
    if (patientCreationStatusByEmr === FETCH_TYPE_SUCCESS && patientEmrData?.message === PATIENT_INSURANCE_NOT_FOUND_IN_EMR) {
      dispatch(setSingleAlertObj({ message: "Patient Insurance is missing in EMR Details. Please change manually as per the actual records.", alertType: "error" }));
      dispatch(updatePatientEMRObjectReducer(null));
      
    }
  }, [patientEmrData?.message === PATIENT_INSURANCE_NOT_FOUND_IN_EMR, patientCreationStatusByEmr])
  //CS-1244 - End
  //CS-1297 - start
  // useEffect(()=>{
  //   if(patientEmrData?.data?.isAutoPverify && patientEmrData?.message !== PATIENT_INSURANCE_NOT_FOUND_IN_EMR){
  //     console.log("%c Line:225 🍌 patientEmrData", "color:#fca650", patientEmrData);
  //     const verificationData = {
  //       insuranceType: "PRIMARY",
  //       insurerPayerCode: "00007",
  //       insurerName: "Medicare",
  //       policy: "34324322242",
  //       npi: patientEmrData?.data?.npi,
  //       provider: patientEmrData?.data?.providerId,
  //       patientId: patientEmrData?.data?.patientId,
  //       practiceId: patientEmrData?.data?.practiceId
  //     }
  //     dispatch(savePatientVerificationDataSkipLoader(verificationData));
  //   }
  //   dispatch(updatePatientEMRObjectReducer(null));
  // },[patientEmrData])

  useEffect(() => {
    dispatch(updatePatientObjectReducer(null));
    dispatch(fetchManufacturersList());
    fetchInitialLists();
  }, []);

  const fetchInitialLists = async () => {
    dispatch(showHideLoadingDialog(true));
    //Don't remove below unused variables
    const responsePractices = await dispatch(
      // getPracticeListByUserRoleOrderSlice(false)
      getPracticeListByUserRoleOrderSlicenew({isActivePracticeOnly: true, skipLoader: true})
    );
    const responseProducts = await dispatch(
      fetchProductListIncludingInactiveByUserRoleOrderSlice({includeProductPrice: false, executedOnly: true, skipLoader: false})
    );
    const prescriptions = await dispatch(getPrescriptionsByPatientId(location?.state?.patientDetails?.patientId));
    dispatch(showHideLoadingDialog(false));
  };

  useEffect(() => {
    const accessibleProductIds = canAccessProviderProducts[0] ? canAccessProviderProducts[0].split(',') : [];
    if (canAccessProviderProducts) {
      if (accessibleProductIds && accessibleProductIds.length > 0) {

        const filteredProducts = productsByUserRoleOrderSlice.filter((product) =>
          accessibleProductIds.includes(product.productId.toString())
        );
        setFilteredeProductsByUserRoleOrderSlice(filteredProducts);
      } else {
        setFilteredeProductsByUserRoleOrderSlice([])
      }
    } else {
      setFilteredeProductsByUserRoleOrderSlice(productsByUserRoleOrderSlice);
    }
  }, [productsByUserRoleOrderSlice, canAccessProviderProducts]);

  const manufacturesList = useMemo(() => {
    let options: { label: string; value: any }[] = [];

    if ((filteredeProductsByUserRoleOrderSlice?.length ?? 0) > 0 && manufacturerInfoList?.length > 0) {
      const uniqueManufacturerIds = (filteredeProductsByUserRoleOrderSlice ?? [])
        .map((product) => product.manufacturerId)
        .filter((id, index, self) => id !== null && self.indexOf(id) === index);

      const filteredManufacturers = manufacturerInfoList.filter((manufacturer) =>
        uniqueManufacturerIds.includes(manufacturer.manufacturerId)
      );

      filteredManufacturers.forEach((item) => {
        options.push({
          label: item.manufacturerName,
          value: item.manufacturerId,
        });
      });
    }

    return options;
  }, [filteredeProductsByUserRoleOrderSlice, manufacturerInfoList]);

  const orderStatusOptions = useMemo(
    () =>
      Object.values(PRODUCT_STATUS).map((status) => ({
        value: status,
        label: status,
      })),
    []
  );

  //CS-1164 START
  const orderAvailabilityOptions = useMemo(
    () =>
      Object.values(ORDER_AVAILABILITY).map((status) => ({
        value: status,
        label: status,
      })),
    []
  );
  //CS-1164 END

  const orderInvoiceStatusOptions = useMemo(
    () =>
      Object.values(ORDER_INVOICE_STATUS).map((status) => ({
        value: status,
        label: status,
      })),
    []
  );

  const ivrStatusOptions = useMemo(() => {
    let statuses: CodeTable[] = [];
    if (allCodeTablesValuesMap) {
      statuses = getCodeTableValuesByTableName(allCodeTablesValuesMap, IVR_STATUS_LIST);
    }
    if (!statuses || statuses.length === 0) {
      dispatch(fetchAllCodeTablesValues());
    }
    let options: { label: string, value: any }[] = [];
    statuses?.map((option) => {
      options.push({ label: option.displayValue, value: option.displayValue });
    });
    return options;
  }, [allCodeTablesValuesMap]);

  //CS-1471 START
  // useEffect(() => {
  //   if (patientInfoObject) {
  //     loadInitialOrderList(1);
  //     loadInitialIVRList(1);
  //   }
  // }, [location.state, filteredeProductsByUserRoleOrderSlice, patientInfoObject]);

  useEffect(() => {
  if (!patientInfoObject?.patientId || !filteredeProductsByUserRoleOrderSlice) return;

  const productsFetchSettled =
    fetchProductsByRoleStatusOrderSlice == null ||
    fetchProductsByRoleStatusOrderSlice === "success" ||
    fetchProductsByRoleStatusOrderSlice === "error";
  if (!productsFetchSettled) return;

  if (filteredeProductsByUserRoleOrderSlice.length === 0) {
    setSectionListsReady(true);
    return;
  }

  if (ivrOrdersLoaded) return;

  setIvrOrdersLoaded(true);
  Promise.all([loadInitialOrderList(1), loadInitialIVRList(1)]).finally(() => {
    setSectionListsReady(true);
  });
}, [patientInfoObject?.patientId, JSON.stringify(filteredeProductsByUserRoleOrderSlice), fetchProductsByRoleStatusOrderSlice]);
  //CS-1471 END

  const loadInitialOrderList = (pNumber: number = 1) => {
    const practiceIds = patientInfoObject?.practiceId ? [Number(patientInfoObject.practiceId)] : [];

    const productIds = filteredeProductsByUserRoleOrderSlice?.map((p) => Number(p.productId)) ?? [];

    const manufacturerIds = manufacturerInfoList?.map((m) => Number(m.manufacturerId)) ?? [];

    const status = orderStatusOptions.map((s) => s.value);
    const orderItemStatus = orderAvailabilityOptions.map((s) => s.value);
    const invoiceStatus = orderInvoiceStatusOptions.map((s) => s.value);

    const searchCriteria: SearchOrder = {
      practiceIds,
      productIds,
      manufacturerIds,
      patientFirstName: "",
      patientLastName: "",
      patientId,
      providerName: "",
      orderNumber: "",
      invoiceNumber: "",
      serialNumber: "",
      fromDate: "",
      toDate: "",
      status,
      orderItemStatus,
      invoiceStatus,
      currentPage: pNumber,
      itemsPerPage: ITEMS_PER_PAGE,
      downloadState: false,
      fromServiceDate: "",
      toServiceDate: "",
      withoutIvr: "",
      alertOrders: false,
    };
    return dispatch(fetchOrdersList({data: searchCriteria, skipLoader:true}));
  };


  const loadInitialIVRList = (pNumber: number = 1) => {
    const practiceIds = patientInfoObject?.practiceId ? [Number(patientInfoObject.practiceId)] : [];
    const productIds = filteredeProductsByUserRoleOrderSlice?.map((p) => Number(p.productId)) ?? [];
    const verificationStatus =
      ivrStatusOptions?.length > 0 ? ivrStatusOptions.map((s) => s.value) : [];

    const today = dayjs().format("MM/DD/YYYY");
    const sixMonthsAgo = dayjs().subtract(6, "month").format("MM/DD/YYYY");

    const searchCriteria: SearchIVRListRequest = {
      practiceId: practiceIds.length === 1 ? practiceIds : [],
      productId: productIds.length > 0 ? productIds : [],
      patientId: patientId,
      productCategory: [],
      patientFirstName: "",
      patientLastName: "",
      verificationStatus,
      ivrNumber: "",
      fromDate: sixMonthsAgo,
      toDate: today,
      currentPage: pNumber,
      itemsPerPage: ITEMS_PER_PAGE,
      alertIVRs: false,
    };

    return dispatch(fetchIVRList({ data: searchCriteria, skipLoader: true }));
  };

  const getLastCreatedOrderDate = (ordersByPatient: OrderInfo[]) => {
    if (!ordersByPatient || ordersByPatient.length === 0) {
      return "N/A";
    }
    const latestOrder = [...ordersByPatient].sort((a, b) => b.orderId - a.orderId)[0];
    const auditTimestamp = latestOrder.orderDate;
    if (!auditTimestamp) {
      return "N/A";
    }
    const dateObj = new Date(auditTimestamp);
    return dateObj.toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }

  const getLastCreatedIvrDate = (ivrListByPatient: IvrListDTO[]) => {
    if (!ivrListByPatient || ivrListByPatient.length === 0) {
      return "N/A";
    }
    const lastIvr = [...ivrListByPatient].sort((a, b) => b.ivrId - a.ivrId)[0];
    const auditTimestamp = lastIvr.createdDate;
    if (!auditTimestamp) {
      return "N/A";
    }
    const dateObj = new Date(auditTimestamp);
    return dateObj.toLocaleString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",

    });
  }
  
useEffect(() => {
  if (!patientInfoObject?.patientId) return;

  if (
    !patientInfoObject?.isAutoPverify ||
    hasTriggeredPverifyRef.current ||
    // !patientEmrData?.data?.isAutoPverify ||
    patientEmrData?.message === PATIENT_INSURANCE_NOT_FOUND_IN_EMR
    // ||isPverifyAlreadyCalled(patientInfoObject?.patientId)
  ) {
    if (!patientInfoObject?.isAutoPverify || patientEmrData?.message === PATIENT_INSURANCE_NOT_FOUND_IN_EMR) {
      setAutoEligibilitySettled(true);
    }
    return;
  }

  hasTriggeredPverifyRef.current = true;
//   const hasValidInsurance = (insurance: any): boolean => {
//   return insurance && typeof insurance === "object" && !!insurance.policy;
// };
// CS-1607 : New logic to extract insurance data with checking valid insurance policy and payer code for new changes
  const hasValidInsurance = (insurance: any): boolean => {
    return insurance && typeof insurance === "object" && !!insurance.policy && !!insurance.insurancePayerCode;
  };
  const primaryInsurance = extractInsuranceData(patientInfoObject?.patientInfo, "PRIMARY_INSURANCE");
  const secondaryInsurance = extractInsuranceData(patientInfoObject?.patientInfo, "SECONDARY_INSURANCE");

  const basePayload = {
    provider: patientInfoObject?.billingType==="INDIVIDUAL" ?(patientInfoObject?.providerId || patientEmrData?.data?.providerId):null,
    patientId: patientInfoObject?.patientId || patientEmrData?.data?.patientId,
    practiceId: patientInfoObject?.practiceId ||patientEmrData?.data?.practiceId,
    npi: patientInfoObject?.npi || patientEmrData?.data?.npi || "",
    isAutoVerify: true,// CS-1325
  };

  const buildPayload = (insurance: any, type: "PRIMARY" | "SECONDARY") => ({
    ...basePayload,
    insuranceType: type,
    insurerPayerCode: insurance?.insurancePayerCode,
    insurerName:insurance?.insuranceName,
    policy: insurance?.policy 
  });

 const runPverify = async () => {
  setLoadingPverify(true);

  const promises = [];
  let blockedInvalidMbi = false;
  const rejectInvalidMedicareMbi = (insurance: any) => {
    if (insurance?.insuranceCategory === "Medicare" && !isValidMedicareMbi(insurance?.policy)) {
      blockedInvalidMbi = true;
      return true;
    }
    return false;
  };

 if (hasValidInsurance(primaryInsurance) && patientInfoObject?.isAutoPverifyPrimary &&patientInfoObject?.status==="ACTIVE") {
  if (!rejectInvalidMedicareMbi(primaryInsurance)) {
    const primaryPayload = buildPayload(primaryInsurance, "PRIMARY");
    promises.push(dispatch(savePatientVerificationDataSkipLoader(primaryPayload)).unwrap());
  }
}

if (hasValidInsurance(secondaryInsurance) && patientInfoObject?.isAutoPverifySecondary &&patientInfoObject?.status==="ACTIVE") {
  if (!rejectInvalidMedicareMbi(secondaryInsurance)) {
    const secondaryPayload = buildPayload(secondaryInsurance, "SECONDARY");
    promises.push(dispatch(savePatientVerificationDataSkipLoader(secondaryPayload)).unwrap());
  }
}

  if (blockedInvalidMbi) {
    const patientName = fullName("", patientInfoObject?.firstName, patientInfoObject?.middleName, patientInfoObject?.lastName);
    dispatch(setSingleAlertObj({
      message: patientName ? `${INVALID_MBI_MESSAGE} Patient: ${patientName}.` : INVALID_MBI_MESSAGE,
      alertType: "error",
    }));
  }

  if (blockedInvalidMbi && promises.length === 0) {
    dispatch(resetAutoPatientVerificationStatus());
    setLoadingPverify(false);
    setAutoEligibilitySettled(true);
    return;
  }

  try {
    const results = await Promise.all(promises); // ✅ Wait for all verifications
    results.forEach(result => {
      setPverifyResults(prev => [...prev, result]);
    });

    markPverifyAsCalled(patientId);

    // ✅ Call summary API AFTER all pVerify requests finish
    const summaryRequest = dispatch(fetchActivePatientBeneficationSummaryByPatientId(patientId.toString()));
    dispatch(resetAutoPatientVerificationStatus())
    await summaryRequest;

    
  } catch (error) {
    console.error("pVerify Error:", error);
  } finally {
    setLoadingPverify(false);
    setAutoEligibilitySettled(true);
  }
};
  if(location?.state?.patientDetails?.isAutoPverify || patientEmrData?.data?.isAutoPverify){
    runPverify();
  }
  dispatch(updatePatientEMRObjectReducer(null));
  
}, [patientInfoObject, patientEmrData, patientId , location]);

// useEffect(() => {
//   if(patientEmrData?.data?.isAutoPverify===false){
//     dispatch(
//       setSingleAlertObj({
//         alertType: "success",
//         // title: "Action Required",
//         message: "Patient added successfully. Please verify the patient details and proceed with creating the IVR.",
//         showButton: true,
//         buttonText: "CREATE IVR",
//         onButtonClick: () => {onCreateIVRClick(patientEmrData?.data) },
        
//       })
//     );

//     dispatch(updatePatientEMRObjectReducer(null));
//   }
// },[patientEmrData?.data?.isAutoPverify])

//  const onCreateIVRClick = async (patientEmrData: any) => {
//       if (patientEmrData.practiceId) {
//         const response = await dispatch(checkAncilliaryAgreementsForPractice(patientEmrData.practiceId));
//         if ( canCreateIVR) {
//           navigate("/ivr", {
//             state: {
//               practiceId: patientEmrData.practiceId,
//               ivrEmailNotification: true,
//               patientData: { from: CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT, patientId: patientEmrData.patientId },
//               productCategory: response.payload === true ? "Collagen" : "Advanced CTP",
//             }
//           });
//         } 
//       }
      
//   }
  //CS-1297 -end

  const fetchPatientDataAndDocuments = async (patientId: number) => {
  try {
    const response = await dispatch(getPatientSaveAuditLog({ patientId: patientId.toString(), isSaveAuditLog: true })).unwrap();
    setPatientInfo(response.data);
    const addressInfo: {
      patientStreetAddress: string;
      patientUnitNumber: string;
      patientCity: string;
      patientState: string;
      patientZip: string;
    } | undefined = response?.data?.patientInfo?.find(
      (info: { infoType: string ,inactiveDate: string }) => info.infoType === "ADDRESS" && info.inactiveDate === null
    )?.patientinfoData;

    if (addressInfo) {
      const addressFields = [
        addressInfo.patientStreetAddress,
        addressInfo.patientUnitNumber,
        addressInfo.patientCity,
        addressInfo.patientState,
        addressInfo.patientZip
      ].filter(Boolean);

      const concatAddress = addressFields.join(", ");
      setAddress(concatAddress);
    }

    // Process documents
    const documents = response?.data?.patientInfo
      ?.filter(
        (info: { 
          patientinfoData: { 
            documentIds?: string[]; 
            ivrDocumentListDTOs?: { 
              documentName: string; 
              auditTimestamp: string;
              isActive?: boolean;
              deletedDate?: string | null;
            }[] 
          } 
        }) =>
          Array.isArray(info.patientinfoData?.documentIds) &&
          Array.isArray(info.patientinfoData?.ivrDocumentListDTOs) &&
          info.patientinfoData.documentIds.length > 0 &&
          info.patientinfoData.ivrDocumentListDTOs.length > 0
      )
      ?.flatMap((info: { 
        infoType: string; 
        patientinfoData: { 
          documentIds: any[]; 
          ivrDocumentListDTOs?: any[] 
        } 
      }) =>
        info.patientinfoData.documentIds.map((docId: string, index: number) => {
          const documentEntry = info.patientinfoData.ivrDocumentListDTOs?.[index];
          if (!documentEntry) {
            return null;
          }

          return {
            infoType: info.infoType,
            documentId: docId,
            documentName: documentEntry.documentName,
            auditTimestamp: documentEntry.auditTimestamp,
            isActive: documentEntry.isActive ?? false,
            isDeleted: documentEntry.deletedDate === null ? false : true,
          };
        }).filter(Boolean)
      );

    const docMap = new Map();

    for (const doc of documents) {
      const existing = docMap.get(doc.documentId);
      if (!existing || (!existing.isActive && doc.isActive)) {
        docMap.set(doc.documentId, doc);
      }
    }

    const finalDocuments = Array.from(docMap.values()).sort((a, b) => {
      return (b.isActive === true ? 1 : 0) - (a.isActive === true ? 1 : 0);
    });

    setDocumentData(finalDocuments);
    setFetchPatient(false);

  } catch (error) {
    console.error("Error fetching patient data:", error);
    setFetchPatient(false);
  }
};

useEffect(() => {
  const patientId = location?.state?.patientDetails?.patientId;
  setPatientID(patientId);
  setValue("xrefId", patientId?.toString());

  if (patientId && (fetchPatient || !patientInfo)) {
    fetchPatientDataAndDocuments(patientId);
  }
  
}, [location, dispatch, fetchPatient]);
 

  // const fetchPatientDocuments = async () => {
  //   try {
  //     const response = await dispatch(getPatient({ patientId: patientID.toString() })).unwrap();

  //     const documents = response?.data?.patientInfo
  //       ?.filter((info: { patientinfoData: { documentIds: any[] } }) => info?.patientinfoData?.documentIds?.length > 0)
  //       ?.flatMap((info: { infoType: string; patientinfoData: { documentIds: any[]; ivrDocumentListDTOs?: any[] } }) =>
  //         info.patientinfoData.documentIds.map((docId: string, index: number) => {
  //           const documentName = info.patientinfoData.ivrDocumentListDTOs?.[index]?.documentName || `Document_${docId}`;
  //           const auditTimestamp = info.patientinfoData.ivrDocumentListDTOs?.[index]?.auditTimestamp;

  //           return {
  //             infoType: info.infoType,
  //             documentId: docId,
  //             documentName: documentName,
  //             auditTimestamp: auditTimestamp
  //           };
  //         })
  //       );

  //     setDocumentData(documents);

  //   } catch (error) {
  //     console.error("Error fetching patient documents:", error);
  //   }
  // };

  const showErrorResponse = (data: any) => {
    setShowErrorResponsePopup({ isShow: true, errorResponse: data });
     }

  const onPdfClick = async (data: any) => {
    //CS-1170 - START
    const actionResult = await dispatch(fetchPatientDocumentsByIds(data.pdfDocId));
    //CS-1170 - END
    if (actionResult.payload) {
      setPDFContent(actionResult.payload.content);
      const patientName = `${location?.state?.patientDetails?.patientName} (DOB: ${location?.state?.patientDetails?.dob}) - Eligibility Check Summary`
      setShowPDF({ isShow: true, patientName:patientName, fileName:patientName })
    }
  }
  
  const handleActionDownload = async (documentId: string) => {
    if (documentId) {
      const actionResult = await dispatch(fetchDocumentById(documentId.toString()));
      const documentData = actionResult.payload;
      if (documentData?.content) {
        downloadBase64File(documentData.content, documentData.documentName, documentData.fileType);
      } else {
        dispatch(setSingleAlertObj({ message: "Document not found!", alertType: "info" }));
      }
    }
  };

    const handleActionPreview = async (row: any, type: string) => {
      const documentId = type === "note" ? row.attachementId : row.documentId;
      if (documentId) {
        const actionResult = await dispatch(
          fetchOrderDocumentsByIds(documentId)
        );
        const documentData = actionResult.payload;
        if (documentData && documentData.content) {
          setPDFContent(documentData.content);
          console.log("documentData", documentData);
          console.log("pdfContent", pdfContent);
          setShowPDF({
            isShow: true,
            patientName: documentData.documentName,//CS-1404 - Dispalying the doc name instead of patient name
            fileName: documentData.documentName,
          });
        } else {
          dispatch(
            setSingleAlertObj({
              message: "Requested Document has not found under server location!",
              alertType: "info",
            })
          );
        }
      }
    };


  useEffect(() => {
    const id = location?.state?.patientDetails?.patientId;
    if (id == null) {
      setBenefitSummaryReady(true);
      return;
    }
    dispatch(fetchActivePatientBeneficationSummaryByPatientId(id.toString())).finally(() => {
      setBenefitSummaryReady(true);
    });
  }, [])
  
  // Fetch medical audit data for patient
  useEffect(() => {
    const fetchMedicalAuditData = async () => {
      // CS-1595 - Only fetch if user has subscribed access to Medical Audit
      if (patientID && hasSubscribedAccessToMedicalAudit) {
        try {
          const response = await dispatch(getPatientAiAuditDataByPatientId(patientID));
          if (response.meta.requestStatus === "fulfilled" && response.payload?.data) {
            // Filter only Medical Audit results
            const auditData = response.payload.data;
            const filteredData = Array.isArray(auditData) 
              ? auditData.filter((audit: any) => audit.serviceName === AI_SERVICE_NAME.MEDICAL_AUDIT_NOTE)
              : [];
            setMedicalAuditData(filteredData);
          }
        } catch (error) {
          console.error("Error fetching medical audit data:", error);
        }
      }
    };
    
    fetchMedicalAuditData();
  }, [patientID, dispatch, hasSubscribedAccessToMedicalAudit]);
  //Need to update this logic to handle auto patient verification when proper pverify api call is for patient is created
  // useEffect(()=>{
  //   if(autoPatientVerificationDataStatus === FETCH_TYPE_SUCCESS){
  //     dispatch(fetchActivePatientBeneficationSummaryByPatientId(location?.state?.patientDetails?.patientId.toString()))
  //     dispatch(resetAutoPatientVerificationStatus())
  //   }else{
  //     return;
  //   }
  // },[autoPatientVerificationDataStatus])
  const getPatientBeneficationSummaryDataHistory = async () => {
      await dispatch(fetchPatientBeneficationSummaryByPatientId(location?.state?.patientDetails?.patientId.toString()));
      setShowPatientBenefitSummaryHistoryPopup(true)
  }
  const patientActiveBenefitActionComponent = (
    row: any,
  ): JSX.Element => {
    return (
      <>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          tooltipMessage="PDF"
          tooltipPlacement="top"
          onClick={() => onPdfClick(row)}
          //CS-1170 - START
          style={{
            display: hideElement(
              !((row.status === "ACTIVE" || row.status === "INACTIVE") && row.pdfDocId !== 0)
            ),
          }}
        //CS-1170 - END
        >
          <PictureAsPdfOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="error"
          size="small"
          variant="outlined"
          tooltipMessage="Error Response"
          tooltipPlacement="top"
          onClick={() => showErrorResponse(row)}
          //CS-1170 - START
          style={{
            display: hideElement(
              !(
                row.status !== "ACTIVE" &&
                row.status !== "INACTIVE" &&
                row.pdfDocId === 0
              )
            ),
          }}
        //CS-1170 - END
        >
          <GppMaybeOutlined fontSize="small" />
        </CustomIconButton>
        <CustomIconButton
          color="warning"
          size="small"
          variant="outlined"
          tooltipMessage="Insurance Eligibility Details"
          tooltipPlacement="top"
          //CS-1170 - START
          onClick={() => { setShowPatientBenefitInsuranceSummaryHistoryPopup(true); setBvsId(row?.parentBvsId) }}
          //CS-1170 - END
          style={{
            display: hideElement(
              !((row.status === "ACTIVE" || row.status === "INACTIVE") && row.pdfDocId !== 0)
            ),
          }}
        >
          <DescriptionOutlined fontSize="small" />
        </CustomIconButton>
      </>
    );
  };

  const getHistoryForType = (documentInfoType: string) => {
    if (!documentInfoType) return [];

    const filteredDocs = documentData.filter(
      doc => doc.infoType === documentInfoType && !(doc.isActive && !doc.isDeleted)
    );

    return filteredDocs.map(doc => ({
      name: doc.documentName,
      docId: doc.documentId,
      type: doc.infoType,
      date: new Date(doc.auditTimestamp).toLocaleString(),
      status: doc.isDeleted
        ? "Deleted"
        : doc.isActive
          ? "Active"
          : "Inactive",
    }));
  };

  const handleActionHistory = (documentInfoType: string) => {
    const history = getHistoryForType(documentInfoType);
    if (history.length > 0) {
      setSelectedHistoryData(history);
      handleHistoryPopup();
    }
  };

  const documentRows = documentData?.map((doc) => ({
    infoType: doc.infoType,
    documentName: doc.documentName,
    auditTimestamp: doc.auditTimestamp,
    isActive: doc.isActive,
    action: (
      <>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          onClick={() => handleActionDownload(doc.documentId)}
          tooltipMessage="Download"
          tooltipPlacement="bottom"
        >
          <Download />
        </CustomIconButton>
        <CustomIconButton
          color="info"
          size="small"
          variant="outlined"
          onClick={() => handleActionPreview(doc, "document")}
          tooltipMessage="Preview"
          tooltipPlacement="bottom"
        >
          <Preview />
        </CustomIconButton>
      </>
    ),
  }));

  const downloadAll = async () => {
    if (!documentData || documentData.length === 0) {
      dispatch(setSingleAlertObj({ message: "No documents to download!", alertType: "info" }));
      return;
    }

    const zip = new JSZip();
    const documentsFolder = zip.folder("documents");

    if (!documentsFolder) {
      console.error("Failed to create documents folder in ZIP.");
      return;
    }

    for (const doc of documentData) {
      await downloadAndAddToZip(doc.documentId.toString(), doc.documentName, documentsFolder);
    }

    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "all_documents.zip");
    });
  };

  const downloadAndAddToZip = async (documentId: string, documentName: string, zipFolder: JSZip) => {
    const actionResult = await dispatch(fetchDocumentById(documentId.toString()));
    const documentData = actionResult.payload;

    if (documentData && documentData.content) {
      const byteCharacters = atob(documentData.content);
      const byteArray = new Uint8Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
      }

      zipFolder.file(documentName, byteArray, { binary: true });
    } else {
      console.error(`Document with ID ${documentId} not found or is empty.`);
    }
  };

  useEffect(() => {
    if (woundInfoRows && woundInfoRows.length > 0) {
      const maxNumber = getMaxWoundInfoKey(woundInfoRows);
      setMaxWoundRowIndex(maxNumber);
    }
  }, [woundInfoRows]);

  const getMaxWoundInfoKey = (rows: WoundInfo[]): number => {
    const maxKey = rows.reduce((max, row) => {
      if (row.woundInfoKey) {
        const parts = row.woundInfoKey.split('_');
        const num = parseInt(parts[parts.length - 1], 10);
        if (!isNaN(num) && num > max) {
          return num;
        }
      }
      return max;
    }, 0);
    return maxKey;
  };

  const generateUniqueId = (index: number): string => {
    return `${`WOUND`}_${index}`;
  };

  const defaultValues = () => {
    const woundInfo = patientInfoObject?.patientInfo?.find(info => info.infoType === 'WOUND_INFO' && info.inactiveDate === null);
    const primaryInsurance = patientInfoObject?.patientInfo?.find(info => info.infoType === 'PRIMARY_INSURANCE' && info.inactiveDate === null);
    const secondaryInsurance = patientInfoObject?.patientInfo?.find(info => info.infoType === 'SECONDARY_INSURANCE' && info.inactiveDate === null);
    const faceSheet = patientInfoObject?.patientInfo?.find(info => info.infoType === 'FACESHEET' && info.inactiveDate === null);

    let processedWoundData = woundInfo?.patientinfoData?.woundInfo?.woundData?.map((woundData: WoundInfo, i: number) => {
      const totalSize = parseFloat(woundData.totalSize as unknown as string);
      const totalSizeFormatted = isNaN(totalSize) ? '0.00' : totalSize.toFixed(2);
      const cptFormatted = Array.isArray(woundData.cpt) ? woundData.cpt.join(', ') : woundData.cpt;
      const lengthValue = parseFloat(woundData.length as unknown as string);
      const widthValue = parseFloat(woundData.width as unknown as string);
      const depthValue = parseFloat(woundData.depth as unknown as string);
      const estimateSurfaceArea = (!isNaN(lengthValue) && !isNaN(widthValue))
        ? (lengthValue * widthValue).toFixed(2)
        : '0.00';
      const totalWoundVolume = (!isNaN(lengthValue) && !isNaN(widthValue) && !isNaN(depthValue))
        ? (lengthValue * widthValue * depthValue).toFixed(2)
        : '0.00';
      const woundInfoKey =  woundData.woundInfoKey ? woundData.woundInfoKey : generateUniqueId(maxWoundRowIndex > 0 ? maxWoundRowIndex + 1 : i);
      return {
        woundType: woundData.woundType,
        procedureLocation: woundData.procedureLocation,
        cpt: cptFormatted,
        cptIds: woundData.cptIds,
        lCode: woundData.lCode,
        lCodeIds: woundData.lCodeIds,
        eCode: woundData.eCode,
        eCodeIds: woundData.eCodeIds,
        iCode: woundData.iCode,
        iCodeIds: woundData.iCodeIds,
        icd10: woundData.icd10,
        otherDxCodes: woundData.woundType === "Surgical Incision0" ? woundData.icd10 : woundData.otherDxCodes,
        noOfApplications: woundData.noOfApplications,
        length: woundData.length,
        width: woundData.width,
        depth: woundData.depth,
        totalSize: totalSizeFormatted,
        exudate: woundData.exudate,
        displayWoundDimensions: `${woundData.length}cm X ${woundData.width}cm X ${woundData.depth}cm`,
        displayEstimateSurfaceArea: `${estimateSurfaceArea}cm²`,
        displayTotalWoundVolume: `${totalWoundVolume}cm³`,
        woundInfoKey: woundInfoKey,
        woundKeyDisplayValue: formatWoundName(woundData.woundType, woundInfoKey)
      };
    });

    const insuranceInfo: insuranceInfo = {
      insuranceName: primaryInsurance?.patientinfoData?.insuranceName || "",
      primaryCommercialInsuranceName: primaryInsurance?.patientinfoData?.primaryCommercialInsuranceName || "",
      policy: primaryInsurance?.patientinfoData?.policy || "",
      isPolicyUnderDifferentName: primaryInsurance?.patientinfoData?.isPolicyUnderDifferentName || 'no',
      isSecondaryInsurance: secondaryInsurance?.patientinfoData?.insuranceName !== undefined
        && secondaryInsurance?.patientinfoData?.insuranceName !== "" ? true : false,
      secondaryInsuranceName: secondaryInsurance?.patientinfoData?.insuranceName || "",
      secondaryCommercialInsuranceName: secondaryInsurance?.patientinfoData?.secondaryCommercialInsuranceName || "",
      secondaryPolicy: secondaryInsurance?.patientinfoData?.policy || "",
      isSecondaryPolicyUnderDifferentName: secondaryInsurance?.patientinfoData?.isPolicyUnderDifferentName || 'no',
      faceSheet: faceSheet?.patientinfoData?.documentIds,

      policyholderFirstName: primaryInsurance?.patientinfoData?.policyHolderFirstName,
      policyholderMiddleName: primaryInsurance?.patientinfoData?.policyHolderMiddleName,
      policyholderLastName: primaryInsurance?.patientinfoData?.policyHolderLastName,
      policyHolderDOB: primaryInsurance?.patientinfoData?.policyHolderDOB,
      insuranceCards: primaryInsurance?.patientinfoData?.documentIds,

      secondarypolicyholderFirstName: secondaryInsurance?.patientinfoData?.policyHolderFirstName,
      secondarypolicyholderMiddleName: secondaryInsurance?.patientinfoData?.policyHolderMiddleName,
      secondarypolicyholderLastName: secondaryInsurance?.patientinfoData?.policyHolderLastName,
      secondaryPolicyHolderDOB: secondaryInsurance?.patientinfoData?.policyHolderDOB,
      secondaryInsuranceCards: secondaryInsurance?.patientinfoData?.documentIds,
    }


    setWoundInfoRows(processedWoundData || []);
    setInsuranceInformation(insuranceInfo);
  }

  useEffect(() => {
    defaultValues();
  }, [patientInfoObject])

  const onViewOldOrderClick = async () => {
    if (patientID) {
      let searchCriteriaOrder: SearchOrder = {
        practiceIds: [],
        manufacturerIds: [],
        patientFirstName: patientInfo?.firstName || "",
        patientLastName: patientInfo?.lastName || "",
        productIds: [],
        providerName: "",
        orderNumber: "",
        invoiceNumber: "",
        serialNumber: "",
        fromDate: "",
        toDate: "",
        status: [],
        orderItemStatus: [],
        invoiceStatus: [],
        currentPage: 1,
        itemsPerPage: ITEMS_PER_PAGE,
        downloadState: false,
        fromServiceDate: '',
        toServiceDate: '',
        patientId: patientID
      };
      navigate("/order_list", { state: { orderListSearchCriteria: searchCriteriaOrder } });
    }
  }
  const onViewOldIVRClick = async () => {
    if (patientID) {
      let searchCriteriaIvr: SearchIVRListRequest = {
        productId: [],
        practiceId: [],
        productCategory: [],
        patientFirstName: patientInfo?.firstName || "",
        patientLastName: patientInfo?.lastName || "",
        verificationStatus: [],
        ivrNumber: '',
        fromDate: "",
        toDate: "",
        patientId: patientID,
        currentPage: 1,
        itemsPerPage: ITEMS_PER_PAGE
      };
      navigate("/ivr_list", { state: { ivrListSearchCriteria: searchCriteriaIvr } })
    }
  }

  useEffect(() => {
    if (allCodeTableValueFetchStatus === "success" && allCodeTablesValuesMap) {
      const sortedDocumentTypes = [
        ...getCodeTableValuesByTableName(allCodeTablesValuesMap, "documentType"),
      ].sort((a, b) => a.displayValue.localeCompare(b.displayValue));
      setDocumentTypes(sortedDocumentTypes);
    }
  }, [allCodeTablesValuesMap, allCodeTableValueFetchStatus]);

  const patientActiveBeneficationSummaryRows: any[] = useMemo(() => {
    const rows: any[] = []
    patientActiveBeneficationSummaryData?.map((item: any) => {
      const row = {
      // CS-1325
      requestedDateTimeAndName: (
          <>
            {item?.requestedDateTime}
            {(
              item?.isAutoVerify || item?.auditUser
            ) && (
              <>
                {" "}
                {/* CS-1325 - start */}
                <span >
                  {item?.isAutoVerify ? "(AUTO)" : `(${item?.auditUser})`}
                </span>
                {/* CS-1325 - End */}
              </>
            )}
          </>
        ),
        //
        provider: item?.providerName,
        insurance: item.insuranceCompanyName,
        policyNo: item.policyTypeWithNumber,
        //CS-1170 - START
        docId: item?.pdfDocId,
        //CS-1170 - END
        status: 
        <Chip label={item?.status} size="small"  sx={{color : getStatusColor(item.status), backgroundColor: "#f5eaea0f"}}/>,
        actionButtons: patientActiveBenefitActionComponent(item),
      }
      rows.push(row);
    })
    return rows;
  }, [patientActiveBeneficationSummaryData]);

  const medicalAuditRows = useMemo(() => {
    if (!medicalAuditData || medicalAuditData.length === 0) return [];

    return medicalAuditData.map((audit: any) => ({
      auditId: audit.auditId || "-",
      auditIdLink: audit.auditId ? (
        <Link
          component="button"
          underline="hover"
          variant="body2"
          onClick={(e) => {
            e.stopPropagation();
             handleRowNavigateToDetails(audit);
          }}
          color={'#00B8D9'}
        >
          {audit.auditId}
        </Link>
      ) : (
        audit.auditId
      ),
      fileName: audit.fileName || "-",
      uploadDate: audit.createdAt || "-",
      uploadedBy: audit.createdByUserName || "-",
      complianceScore: (
        <Typography
          sx={{
            color: getComplianceColor(audit.currentCompliancePercentage),
            fontWeight: 600
          }}
        >
          {audit.currentCompliancePercentage}%
        </Typography>
      ) as any,
      // action: (
      //   <CustomIconButton
      //     color="success"
      //     size="small"
      //     variant="outlined"
      //     tooltipMessage="View Audit"
      //     tooltipPlacement="top"
      //     onClick={() => handleViewMedicalAudit(audit.auditId)}
      //   >
      //     <VisibilityOutlined fontSize="small" />
      //   </CustomIconButton>
      // ),
    }));
  }, [medicalAuditData]);

  const prescriptionRows = useMemo(() => {
    if (!prescriptions || prescriptions.length === 0) return [];

    return prescriptions.map((p) => {
      const loc = p.location;
      const locationDisplay = loc
        ? [
          loc.streetAddress,
          loc.unitNumber,
          loc.city,
          loc.state,
          loc.zipCode,
        ]
          .filter(Boolean)
          .join(", ") || "-"
        : "-";

      return {
        batchId: p.batchId ?? "-",
        providerName: p.providerName ?? "-",
        location: locationDisplay,
        createdAt: p.createdAt
          ? new Date(p.createdAt).toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
          })
          : "-",
        actionButtons: p.documentId ? (
          <CustomIconButton
            color="info"
            size="small"
            variant="outlined"
            tooltipMessage="Preview Document"
            tooltipPlacement="top"
            onClick={() =>
              handleActionPreview({ documentId: p.documentId }, "document")
            }
          >
            <PreviewOutlined fontSize="small" />
          </CustomIconButton>
        ) : null,
      };
    });
  }, [prescriptions]);

  const handleClose = () => {
    setShowIVRListPopup(false);
  }

  const formatDocumentName = (data: FormatDocumentNameParams) => {
    const maxLength = 20;
    if (!data.name) return `Document_${data.docId}`;
    
    const lastDotIndex = data.name.lastIndexOf('.');
    
    if (lastDotIndex > 0) {
      const baseName = data.name.substring(0, lastDotIndex);
      const extension = data.name.substring(lastDotIndex);
      
      if (baseName.length > (maxLength)) {
        return `${baseName.substring(0, maxLength)}...${extension}`;
      }
      return data.name;
    } 
    else if (data.name.length > (maxLength)) {
      return `${data.name.substring(0, maxLength)}...`;
    }
    return data.name;
  };

  //Unmount
  useEffect(() => () => {
    dispatch(updatePatientObjectReducer(null));
    dispatch(resetIVRList());
    dispatch(resetPatientActiveBeneficationSummaryData());
    dispatch(resetOrderListInfo());
    setWoundInfoRows([]);
    setDocumentData([]);
  }, []);

  const onCreateIVRButtonClick = async () => {
    if (patientInfoObject.practiceId) {
      const response = await dispatch(checkAncilliaryAgreementsForPractice(patientInfoObject.practiceId));
      if (userInfo?.entityName !== USER_ROLE_ENTITY_NAMES.ADMIN && canCreateIVR) {
        navigate("/ivr", {
          state: {
            practiceId: patientInfoObject.practiceId,
            ivrEmailNotification: true,
            patientData: { from: CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT, patientId: patientID },
            // CS-1728 - Replacing static label to dynamic constant
            productCategory: response.payload === true ? PRODUCT_CATEGORY.CONSERVATIVE : PRODUCT_CATEGORY.ADVANCED,
          }
        });
      } else {
        setShowIVRSelectionPopup(true);
      }
    }
  }

  const patientOrders = [
    {
      orderId: "O2025184019",
      product: "Biovance",
      provider: "MD James Miller",
      status: "PLACED",
      dos: "07/05/2025",
    },
    {
      orderId: "O2025184011",
      product: "Product 1",
      provider: "MDAA Miller",
      status: "PLACED",
      dos: "03/02/2025",
    },
    {
      orderId: "O2025184051",
      product: "Product 2",
      provider: "OAOA",
      status: "PLACED",
      dos: "02/02/2025",
    },
  ];

  const hasVisibleActions = useMemo(() => {
    return actions.some(action => !action.isHidden);
  }, [actions]);

  const hasIVRTabData = (ivrSummaryRows?.length > 0 || patientActiveBeneficationSummaryRows?.length > 0);
  const hasMedicalAuditTabData = hasSubscribedAccessToMedicalAudit && medicalAuditRows.length > 0;
  const hasOrderTabData = orderSummaryRows.length > 0;
  const hasPrescriptionTabData = prescriptionRows.length > 0;
  const hasWoundTabData = woundInfoRows.length > 0;
  const hasDocumentTabData = documentRows && documentRows.length > 0;

  const patientTabs = useMemo<SectionTabItem[]>(() => {
    const tabs: SectionTabItem[] = [];
    if (hasMedicalAuditTabData) {
      tabs.push({ id: "audit", label: "Medical Audit", icon: <AssignmentOutlined fontSize="small" /> });
    }
    if (hasIVRTabData) {
      tabs.push({ id: "ivr", label: "IVR & Eligibility", icon: <LocalHospitalOutlined fontSize="small" /> });
    }
    if (hasOrderTabData) {
      tabs.push({ id: "orders", label: "Orders", icon: <ReceiptLongOutlined fontSize="small" /> });
    }
    if (hasPrescriptionTabData) {
      tabs.push({ id: "prescriptions", label: "Prescriptions", icon: <DescriptionOutlined fontSize="small" /> });
    }
    if (hasWoundTabData) {
      tabs.push({ id: "wound", label: "Wound Data", icon: <Wysiwyg fontSize="small" /> });
    }
    if (hasDocumentTabData) {
      tabs.push({ id: "documents", label: "Documents", icon: <FolderOutlined fontSize="small" /> });
    }
    return tabs;
  }, [hasMedicalAuditTabData, hasIVRTabData, hasOrderTabData, hasPrescriptionTabData, hasWoundTabData, hasDocumentTabData]);

  const selectedTab = patientTabs.some((tab) => tab.id === activeTab)
    ? activeTab
    : (patientTabs[0]?.id || "");

  const spreadInfoCards =
    !!patientInfo &&
    patientTabs.length === 0 &&
    sectionListsReady &&
    benefitSummaryReady &&
    autoEligibilitySettled &&
    !loadingPverify;

  return (
    <>
      {showPDF.isShow &&
        <PDFViewer
          isOpen={showPDF.isShow}
          onClose={() => { setShowPDF({ isShow: false, patientName: "", fileName: "" }) }}
          title={showPDF.patientName}
          fileName={showPDF.fileName}
          base64String={documentDataFromCommonApi?.content ? documentDataFromCommonApi?.content : pdfContent}
        />
      }
      {showErrorResponsePopup.isShow &&
        <BenefitVerificationErrorResponse
          open={showErrorResponsePopup.isShow}
          onClose={() => { setShowErrorResponsePopup({ isShow: false, errorResponse: "" }) }}
          title="Error Response"
          response={showErrorResponsePopup.errorResponse}
          canViewErrorResponse={canViewEligibilityErrorResponse}
        />}
      <PatientBenefitSummaryHistoryPopup
              open={showPatientBenefitSummaryHistoryPopup}
              onClose={() => setShowPatientBenefitSummaryHistoryPopup(false)}
              patientName={location?.state?.patientDetails?.patientName}
              patientDob={location?.state?.patientDetails?.dob}
            />
      <PatientBenefitInsuranceDetailsPopup
        open={showPatientBenefitInsuranceSummaryHistoryPopup}
        onClose={() => { setShowPatientBenefitInsuranceSummaryHistoryPopup(false); dispatch(resetPatientActiveBeneficationInsuranceSummaryData());setBvsId(null); }}
        bvsId={bvsid}
      />
      
      {/* Medical Note Audit Popup */}
      <MedicalNoteAuditPopup
        open={showMedicalAuditPopup}
        onClose={handleCloseMedicalAuditPopup}
        initialAuditData={selectedMedicalAuditData}
        auditCompleted={true}
      />
      
      <Box sx={{ mx: { xs: "10px", sm: "20px" }, mt: "12px", pb: "72px" }}>
        <Box mb={2} display="flex" alignItems="flex-start" justifyContent="space-between" flexWrap="wrap" gap={1.5}>
          <Box display="flex" alignItems="flex-start" gap={1.5}>
            <PageBackButton
              tooltip={null}
              onClick={(e) => {
                e.stopPropagation();
                if (location.state?.fromEdit) {
                  navigate("/patients", { state: { withSearchHistory: true } });
                } else {
                  navigate(-1);
                }
              }}
            />
            <Box>
              <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: mTokens.textSecondary, textTransform: "uppercase", letterSpacing: "0.12em", mb: 0.3 }}>
                Patients / Patient Details
              </Typography>
              <Typography component="h1" sx={{ fontSize: "1.6rem", fontWeight: 800, color: mTokens.textPrimary, lineHeight: 1.1 }}>
                Patient Details
              </Typography>
            </Box>
          </Box>
          <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
            {alert && (
              <FixedAlertCard
                message={alert.message}
                showButton={alert.showButton}
                buttonText={alert.buttonText}
                onButtonClick={() => onCreateIVRButtonClick()}
              />
            )}
            {canEditPatient && (
              <Button
                color="info"
                variant="outlined"
                removeUpperCase
                onClick={() =>
                  navigate("/editPatient", {
                    state: { patientDetails: { isPatientEdit: true, patientId: patientID } },
                  })
                }
                startIcon={<ModeOutlined fontSize="small" />}
                sx={outlineAccentBtnSx}
              >
                Edit
              </Button>
            )}

            <ActionMenu label="Action" actions={actions} disabled={!hasVisibleActions} removeUpperCase sx={outlineAccentBtnSx} />
          </Box>
        </Box>

        <Box
          data-testid="patient-detail-layout"
          data-layout={spreadInfoCards ? "spread" : "sidebar"}
          sx={{
            display: "grid",
            gridTemplateColumns: spreadInfoCards ? "minmax(0, 1fr)" : { xs: "1fr", md: "minmax(0, 1.9fr) minmax(0, 0.85fr)" },
            gap: 2,
            alignItems: "flex-start",
          }}
        >
          <Box
            sx={spreadInfoCards ? {
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: insuranceInformation?.secondaryInsuranceName
                  ? "minmax(0, 1.15fr) minmax(0, 0.9fr) minmax(0, 0.9fr)"
                  : "minmax(0, 1.15fr) minmax(0, 0.85fr)",
              },
              gap: 2,
              minWidth: 0,
              alignItems: "start",
            } : {
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
              order: { xs: 1, md: 2 },
              minWidth: 0,
              position: { md: "sticky" },
              top: { md: 12 },
              alignSelf: "start",
            }}
          >
            <Box sx={cardSx}>
              <SectionHeader icon={<PersonOutlined fontSize="small" />} title="Patient Info" />
              <Box sx={{ px: 2.8, py: 1 }}>
                {/* CS-1404 - Start */}
                <InfoRow
                  label="Patient Name"
                  value={
                    patientInfo
                      ? `${patientInfo.firstName} ${patientInfo.middleName ? patientInfo.middleName + " " : ""}${patientInfo.lastName}`
                      : "-"
                  }
                />
                <InfoRow label="Patient ID" value={patientInfo?.patientCode} />
                {/* CS-1404 - End */}
                <InfoRow label="DOB" value={patientInfo?.birthDate || "-"} />
                <InfoRow label="Gender" value={patientInfo?.gender || "-"} />
                {patientInfo?.dateOfSurgery && (
                  <InfoRow label="Date of Surgery" value={patientInfo?.dateOfSurgery || ""} />
                )}
                <InfoRow label="Patient's Address" value={address || "-"} />
                <InfoRow label="Practice Name" value={patientInfo?.practiceName || "-"} />
              </Box>
            </Box>

            <Box sx={cardSx}>
              <SectionHeader
                icon={<HealthAndSafetyOutlined fontSize="small" />}
                title="Primary Insurance"
                action={
                  getHistoryForType("PRIMARY_INSURANCE").length > 0 ? (
                    <Button
                      variant="outlined"
                      removeUpperCase
                      onClick={() => handleActionHistory("PRIMARY_INSURANCE")}
                      startIcon={<HistoryOutlined fontSize="small" />}
                      style={{ display: `${hideElement(!canViewHistory)}` }}
                      sx={outlineAccentBtnSx}
                    >
                      History
                    </Button>
                  ) : undefined
                }
              />
              <Box sx={{ px: 2.8, py: 1 }}>
                <InfoRow
                  label="Plan"
                  value={`${insuranceInformation?.insuranceName || "-"}${insuranceInformation?.primaryCommercialInsuranceName ? ` (${insuranceInformation?.primaryCommercialInsuranceName})` : ""}`}
                />
                <InfoRow label="Policy #" value={insuranceInformation?.policy || "-"} />
                {insuranceInformation?.isPolicyUnderDifferentName !== "no" && (
                  <>
                    <InfoRow
                      label="Policy Holder Name"
                      value={(`${insuranceInformation?.policyholderFirstName + " "} ${insuranceInformation?.policyholderMiddleName ? insuranceInformation?.policyholderMiddleName + " " : ""} ${insuranceInformation?.policyholderLastName}`) || "-"}
                    />
                    <InfoRow label="Policy Holder DOB" value={insuranceInformation?.policyHolderDOB || ""} />
                  </>
                )}

                {insuranceInformation?.insuranceCards && Array.isArray(insuranceInformation?.insuranceCards) && (
                  insuranceInformation.insuranceCards.map((docId, index) => {
                    const document = documentData.find(doc => doc.documentId === docId) || {};
                    return (
                      <React.Fragment key={index}>
                        {(document.auditTimestamp) && (
                          <InfoRow
                            label="Card"
                            value={
                              <Box display="flex" flexDirection="column">
                                <Box display="flex" justifyContent="space-between" alignItems="center">
                                  {/* CS-1404 */}
                                  <Typography
                                    sx={{
                                      ...fieldValueSx,
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                      flex: 1,
                                      mr: 1
                                    }}
                                    title={document.documentName}
                                  >
                                    {document.documentName}
                                  </Typography>
                                  {/*  */}
                                  <Box display="flex">
                                    <CustomIconButton
                                      color="info"
                                      size="small"
                                      variant="outlined"
                                      onClick={() => handleActionDownload(docId)}
                                      tooltipMessage="Download"
                                      tooltipPlacement="bottom"
                                    >
                                      <DownloadOutlined />
                                    </CustomIconButton>
                                    <CustomIconButton
                                      color="info"
                                      size="small"
                                      variant="outlined"
                                      onClick={() => handleActionPreview(document, "document")}
                                      tooltipMessage="Preview"
                                      tooltipPlacement="bottom"
                                    >
                                      <PreviewOutlined />
                                    </CustomIconButton>
                                  </Box>
                                </Box>
                                {document.auditTimestamp && (
                                  <Typography sx={{ fontSize: "0.72rem", fontWeight: 400, color: mTokens.textSecondary, mt: 0.2 }}>
                                    Last Update: {document?.auditTimestamp}
                                  </Typography>
                                )}
                              </Box>
                            }
                          />
                        )}
                      </React.Fragment>
                    );
                  })
                )}
              </Box>
            </Box>

            {insuranceInformation?.secondaryInsuranceName && (
              <Box sx={cardSx}>
                <SectionHeader
                  icon={<VerifiedUserOutlined fontSize="small" />}
                  title="Secondary Insurance"
                  action={
                    getHistoryForType("SECONDARY_INSURANCE").length > 0 ? (
                      <Button
                        variant="outlined"
                        removeUpperCase
                        onClick={() => handleActionHistory("SECONDARY_INSURANCE")}
                        startIcon={<HistoryOutlined fontSize="small" />}
                        style={{ display: `${hideElement(!canViewHistory)}` }}
                        sx={outlineAccentBtnSx}
                      >
                        History
                      </Button>
                    ) : undefined
                  }
                />
                <Box sx={{ px: 2.8, py: 1 }}>
                  <InfoRow
                    label="Plan"
                    value={`${insuranceInformation?.secondaryInsuranceName || "-"}${insuranceInformation?.secondaryCommercialInsuranceName ? ` (${insuranceInformation?.secondaryCommercialInsuranceName})` : ""}`}
                  />
                  <InfoRow label="Policy #" value={insuranceInformation?.secondaryPolicy || "-"} />
                  {insuranceInformation?.isSecondaryPolicyUnderDifferentName !== "no" && (
                    <>
                      <InfoRow
                        label="Policy Holder Name"
                        value={(`${insuranceInformation?.secondarypolicyholderFirstName + " "} ${insuranceInformation?.secondarypolicyholderMiddleName ? insuranceInformation?.secondarypolicyholderMiddleName + " " : ""} ${insuranceInformation?.secondarypolicyholderLastName}`) || "-"}
                      />
                      <InfoRow label="Policy Holder DOB" value={insuranceInformation?.secondaryPolicyHolderDOB || ""} />
                    </>
                  )}
                  {insuranceInformation?.secondaryInsuranceCards && Array.isArray(insuranceInformation?.secondaryInsuranceCards) && (
                    insuranceInformation.secondaryInsuranceCards.map((docId, index) => {
                      const document = documentData.find(doc => doc.documentId === docId) || {};
                      return (
                        <React.Fragment key={index}>
                          {(document.auditTimestamp) && (
                            <InfoRow
                              label="Card"
                              value={
                                <Box display="flex" flexDirection="column">
                                  <Box display="flex" justifyContent="space-between" alignItems="center">
                                    {/* CS-1404 */}
                                    <Typography
                                      sx={{
                                        ...fieldValueSx,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        flex: 1,
                                        mr: 1
                                      }}
                                      title={document.documentName}
                                    >
                                      {document.documentName}
                                    </Typography>
                                    {/*  */}
                                    <Box display="flex">
                                      <CustomIconButton
                                        color="info"
                                        size="small"
                                        variant="outlined"
                                        onClick={() => handleActionDownload(docId)}
                                        tooltipMessage="Download"
                                        tooltipPlacement="bottom"
                                      >
                                        <DownloadOutlined />
                                      </CustomIconButton>
                                      <CustomIconButton
                                        color="info"
                                        size="small"
                                        variant="outlined"
                                        onClick={() => handleActionPreview(document, "document")}
                                        tooltipMessage="Preview"
                                        tooltipPlacement="bottom"
                                      >
                                        <PreviewOutlined />
                                      </CustomIconButton>
                                    </Box>
                                  </Box>
                                  {document.auditTimestamp && (
                                    <Typography sx={{ fontSize: "0.72rem", fontWeight: 400, color: mTokens.textSecondary, mt: 0.2 }}>
                                      Last Update: {document?.auditTimestamp}
                                    </Typography>
                                  )}
                                </Box>
                              }
                            />
                          )}
                        </React.Fragment>
                      );
                    })
                  )}
                </Box>
              </Box>
            )}
          </Box>

          {patientTabs.length > 0 && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, order: { xs: 2, md: 1 }, minWidth: 0 }}>
            <SectionTabNav tabs={patientTabs} activeTab={selectedTab} onTabChange={setActiveTab} />

            {selectedTab === "audit" && hasMedicalAuditTabData && (
            <Box sx={cardSx}>
              <SectionHeader icon={<AssignmentOutlined fontSize="small" />} title="Medical Audit List" />
              <Box sx={{ px: 2.8, py: 1 }}>
                <Box sx={{ overflowX: 'auto' }}>
                  <CustomTable
                    columns={medicalAuditColumn}
                    rows={medicalAuditRows}
                    disablePagination={true}
                    showMenu={false}
                    sx={patientTableSx}
                  />
                </Box>
              </Box>
            </Box>
          )}

          {selectedTab === "ivr" && hasIVRTabData && (
            <Box sx={cardSx}>
              <SectionHeader icon={<LocalHospitalOutlined fontSize="small" />} title="IVR List" />
              <Box sx={{ px: 2.8, py: 1 }}>
                {ivrSummaryRows?.length > 0 && (
                  <>
                    <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1} sx={{ py: 1 }}>
                      <Typography sx={subSectionTitleSx}>
                        Manufacturer Verification
                      </Typography>
                      <Button variant="outlined" removeUpperCase onClick={() => onViewOldIVRClick()} sx={outlineAccentBtnSx}>
                        View all IVRS
                      </Button>
                    </Box>
                    <Box sx={{ overflowX: "auto", pb: 1 }}>
                      <CustomTable
                        columns={ivrColumn}
                        rows={ivrSummaryRows || []}
                        disablePagination={true}
                        showMenu={true}
                        sx={patientTableSx}
                      />
                    </Box>
                  </>
                )}

                {patientActiveBeneficationSummaryRows?.length > 0 && (
                  <>
                    <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1} sx={{ py: 1 }}>
                      <Typography sx={subSectionTitleSx}>
                        {/* CS-1404 - Label Changes */}
                        Automated Eligibility Check - pVerify
                      </Typography>
                      <Button
                        variant="outlined"
                        removeUpperCase
                        onClick={getPatientBeneficationSummaryDataHistory}
                        startIcon={<HistoryOutlined fontSize="small" />}
                        sx={outlineAccentBtnSx}
                      >
                        History
                      </Button>
                    </Box>
                    <Box sx={{ overflowX: "auto", pb: 1 }}>
                      <CustomTable
                        columns={patientBenefitSummaryColumn}
                        rows={patientActiveBeneficationSummaryRows || []}
                        // actionComponent={(row: any, rowIndex: number) =>
                        //   patientActiveBenefitActionComponent(row, rowIndex)
                        // }
                        showPverifySkeleton={loadingPverify} //CS-1297
                        disablePagination={true}
                        showMenu={true}
                        sx={patientTableSx}
                      />
                    </Box>
                  </>
                )}
              </Box>
            </Box>
          )}


          {selectedTab === "orders" && hasOrderTabData && (
            <Box sx={cardSx}>
              <SectionHeader
                icon={<ReceiptLongOutlined fontSize="small" />}
                title="Order List"
                action={
                  <Button
                    variant="outlined"
                    removeUpperCase
                    onClick={() => onViewOldOrderClick()}
                    sx={outlineAccentBtnSx}
                  >
                    View all orders
                  </Button>
                }
              />
              <Box sx={{ px: 2.8, py: 1 }}>
                <Box sx={{ overflowX: "auto", pb: 1 }}>
                  <CustomTable
                    columns={orderColumn}
                    rows={orderSummaryRows || []}
                    disablePagination={true}
                    showMenu={true}
                    sx={patientTableSx}
                  />
                </Box>
              </Box>
            </Box>
          )}

          {selectedTab === "prescriptions" && hasPrescriptionTabData && (
            <Box sx={cardSx}>
              <SectionHeader icon={<DescriptionOutlined fontSize="small" />} title="Prescriptions" />
              <Box sx={{ px: 2.8, py: 1 }}>
                <Box sx={{ overflowX: "auto" }}>
                  <CustomTable
                    columns={prescriptionColumn}
                    rows={prescriptionRows}
                    disablePagination={true}
                    showMenu={false}
                    sx={patientTableSx}
                  />
                </Box>
              </Box>
            </Box>
          )}

          {selectedTab === "wound" && hasWoundTabData && (
            <Box sx={cardSx}>
              <SectionHeader icon={<Wysiwyg fontSize="small" />} title="Data" />
              <Box sx={{ px: 2.8, py: 1 }}>
                <Box sx={{ overflowX: "auto", pb: 1 }}>
                  <CustomTable
                    columns={woundInfoTableColumns}
                    rows={woundInfoTableRows || []}
                    disablePagination={true}
                    showMenu={true}
                    sx={patientTableSx}
                  />
                </Box>
              </Box>
            </Box>
          )}

          {selectedTab === "documents" && hasDocumentTabData && (
            <Box sx={cardSx}>
              <SectionHeader
                icon={<FolderOutlined fontSize="small" />}
                title="Patient Documents"
                action={
                  documentRows && documentRows.length > 0 ? (
                    <Button
                      startIcon={<DownloadOutlined />}
                      variant="outlined"
                      removeUpperCase
                      onClick={downloadAll}
                      sx={outlineAccentBtnSx}
                    >
                      Download All
                    </Button>
                  ) : undefined
                }
              />
              <Box sx={{ px: 2.8, py: 1.8 }}>
                  {documentRows && documentRows.length > 0 ? (
                    Object.entries(
                      documentRows
                        .filter(
                          (row) =>
                            ![
                              PATIENT_IVR_INFO_TYPES.PRIMARY_INSURANCE,
                              PATIENT_IVR_INFO_TYPES.SECONDARY_INSURANCE,
                            ].includes(row.infoType)
                        )
                        .reduce<Record<string, any[]>>((acc, row) => {
                          const key = row.infoType;
                          if (!acc[key]) acc[key] = [];
                          acc[key].push(row);
                          return acc;
                        }, {})
                    ).map(([infoType, group], index) => {
                      const filteredInfoType =
                        documentTypes.find((type) => type.keyName === infoType)?.displayValue ||
                        infoType;
                      if (!group.some(row => row.isActive)) return null;
                      return (
                        <Box key={index}>
                          {group.map((row, idx) => {
                            if (!row.isActive) return null;
                            return (
                              <Grid
                                key={idx}
                                container
                                spacing={2}
                                alignItems="center"
                                sx={{
                                  paddingY: 1.2,
                                  overflowX: "auto",
                                }}
                              >
                                <Grid item md={3} xs={12}>
                                  {idx === 0 && (
                                    <>
                                      <Typography sx={fieldLabelSx}>Doc Type</Typography>
                                      <Typography sx={fieldValueSx}>
                                        {filteredInfoType}
                                        {" "}
                                        {getHistoryForType(row.infoType).length > 0 && (
                                          <CustomIconButton
                                            color="warning"
                                            size="small"
                                            variant="outlined"
                                            onClick={() => handleActionHistory(row.infoType)}
                                            tooltipMessage="History"
                                            tooltipPlacement="bottom"
                                          >
                                            <HistoryOutlined />
                                          </CustomIconButton>
                                        )}
                                      </Typography>
                                    </>
                                  )}
                                </Grid>
                                <Grid item md={4} xs={12}>
                                  {idx === 0 && (
                                    <Typography sx={fieldLabelSx}>Doc Name</Typography>
                                  )}
                                  {/* CS-1404 */}
                                  <Tooltip title={row.documentName} placement="top" arrow>
                                    <Typography
                                      sx={{
                                        ...fieldValueSx,
                                        fontWeight: 500,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        display: "block",
                                        maxWidth: '100%',
                                        cursor: "default",
                                      }}
                                    >
                                      {row.documentName}
                                    </Typography>
                                  </Tooltip>
                                  {/*  */}
                                </Grid>
                                <Grid item md={3} xs={9}>
                                  {idx === 0 && (
                                    <Typography sx={fieldLabelSx}>
                                      Last Update Time
                                    </Typography>
                                  )}
                                  <Typography sx={{ fontSize: "0.85rem", color: mTokens.textSecondary, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                    {row.auditTimestamp}
                                  </Typography>
                                </Grid>
                                <Grid item md={2} xs={3}>
                                  {idx === 0 && (
                                    <Typography
                                      sx={{ ...fieldLabelSx, display: { sm: "block", xs: "none" } }}
                                    >
                                      Action
                                    </Typography>
                                  )}
                                  {row.action}
                                </Grid>
                              </Grid>
                            );
                          })}
                          {index <
                            Object.entries(
                              documentRows.filter(
                                (row) =>
                                  ![
                                    PATIENT_IVR_INFO_TYPES.PRIMARY_INSURANCE,
                                    PATIENT_IVR_INFO_TYPES.SECONDARY_INSURANCE,
                                  ].includes(row.infoType)
                              )
                            ).length - 1 && (
                              <Box
                                sx={{
                                  borderBottom: "1px dashed",
                                  borderColor: mTokens.border,
                                  my: 1,
                                }}
                              />
                            )}
                        </Box>
                      );
                    })
                  ) : (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      textAlign="center"
                      minHeight="150px"
                    >
                      <Typography sx={{ fontSize: "0.95rem", fontWeight: 700, color: mTokens.textSecondary }}>No documents available.</Typography>
                    </Box>
                  )}
              </Box>
            </Box>
          )}
          </Box>
          )}
        </Box>

        <DocumentHistoryPopup
          onClose={handleHistoryPopup}
          documentData = {selectedHistoryData}
          open={showHistoryPopup}
          title="Archive Documents"
          downloadFile={true}
        />
        {showIVRSelectionPopup &&
          <IVRPracticeSelectionPopup
            open={showIVRSelectionPopup}
            onClose={() => {
              setShowIVRSelectionPopup(false);
            }}
            patientData={{ from: CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT, patientId: patientID }}
            practiceId={patientInfoObject.practiceId}
          />
        }
        {showInfoPopup.show &&
          <InfoPopup
            open={showInfoPopup.show}
            content={showInfoPopup.message}
            onClose={onClickInfoPopup}
            severity="info"
            title={showInfoPopup.title}
          />
        }
        {showIVRSelectionPopup &&
          <IVRPracticeSelectionPopup
            open={showIVRSelectionPopup}
            onClose={() => {
              setShowIVRSelectionPopup(false);
            }}
            patientData={patientInfoObject ? { from: CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT, patientId: patientInfoObject.patientId } : null}
            practiceId={patientInfoObject?.practiceId}
          />
        }

        {showIVRListPopup && (
          <CreateOrderIVRListPopup
            open={showIVRListPopup}
            onClose={handleClose}
            orderFromPatientList={true}
            patientId={selectedPatient?.patientId}
            practiceId={selectedPatient?.practiceId}
            patientData={selectedPatientData}
            practiceName={selectedPatientData?.practiceName}
            providerId={selectedPatient?.providerId}
          />
        )}

        <RecordPastOrderPopup
          onClose={handleRecordPastOrderPopup}
          open={showRecordPastOrderPopup}
          patientData={selectedPatientData}
          patientId={selectedPatient?.patientId}
          practiceId={selectedPatient?.practiceId}
        />

        {confirmDeleteOptionPopup && (
          <OptionsPopup
            open={confirmDeleteOptionPopup}
            onClose={() => setConfirmDeleteOptionPopup(false)}
            variant="confirm"
            message={`Are you sure you want to delete this patient?`}
            buttons={[
              {
                name: "Confirm",
                color: "primary",
                onClick: () => deletePatientbyId(),
              },
              { name: "Cancel", color: "secondary", onClick: () => { setConfirmDeleteOptionPopup(false) } },
            ]}
          />
        )}

        {showEligibilityPopup && (
          <PatientEligibilityPopUp
            patientData={selectedPatient}
            open={showEligibilityPopup}
            onClose={() => { setShowEligibilityPopup(false); setVerifyBenefitClick(false); setSelectedPatient(null); setFetchPatient(true); }}
          />
        )}

        {showOptionPopup.show &&
          <OptionsPopup
            open={showOptionPopup.show}
            onClose={() => setShowOptionsPopup({ message: "", show: false })}
            variant={showOptionPopup.variant}
            message={<>{showOptionPopup.message}</>}
            buttons={showOptionPopup.buttons}
            title={showOptionPopup.title}
            obj={showOptionPopup.obj}
          />
        }
        <PatientRequestRx patient={rxPatient} onClose={() => setRxPatient(null)} /> {/* CS-2075 */}
      </Box>
    </>
  );
};

export default PatientDetails